"use strict";

var _defineProperty = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _objectWithoutProperties = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _taggedTemplateLiteral = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");
var _excluded = ["windowed"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PhotoboothGifCell;
var _qrcode = require("qrcode.react");
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _selfie_segmentation = require("@mediapipe/selfie_segmentation");
var _AzertyKeyboard = _interopRequireDefault(require("./AzertyKeyboard"));
var _utils = require("../utils");
var _html2canvas = _interopRequireDefault(require("html2canvas"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
var pulse = (0, _styledComponents.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.15);\n  }\n  100% {\n    transform: scale(1);\n  }\n"])));
var spin = (0, _styledComponents.keyframes)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  to { transform: rotate(360deg); }\n"])));

// Loading spinner shown while the camera initializes. Color is admin-configurable.
var Spinner = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 64px;\n  height: 64px;\n  margin: -32px 0 0 -32px;\n  border-radius: 50%;\n  border: 5px solid rgba(255, 255, 255, 0.25);\n  border-top-color: ", ";\n  animation: ", " 1s linear infinite;\n  z-index: 4;\n  pointer-events: none;\n"])), function (props) {
  return props.color || '#ffffff';
}, spin);

// Styled Components
var Container = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  height: 100%;\n  width: 100%;\n  position: relative;\n  overflow-y: auto;\n  box-sizing: border-box;\n"])));
var ActionButton = _styledComponents.default.button(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  display: block;\n  border-radius: 120px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 20rem;\n  padding: 14px 10px;\n  font-size: calc(1.4rem * var(--text-scale, 1));\n  margin-top: 0.3rem;\n  text-transform: uppercase;\n  background: #FFFFFF; /* Transparent white */\n  border: none;\n  font-weight: bold;\n  box-shadow: none;\nfont-family: inherit;\n"])));
var ButtonGroup = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: absolute;\n  /* Shares share_controls_offset with ShareOptionsContainer \u2014 see the note there. */\n  top: calc(", " + ", "%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  z-index: 100;\n"])), function (props) {
  return props.square ? '10%' : '2%';
}, function (props) {
  return props.offset != null ? props.offset : 0;
});
var SecondaryButton = (0, _styledComponents.default)(ActionButton)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 15rem;\n  padding: 14px 10px;\n  font-size: calc(1rem * var(--text-scale, 1) * ", ");\n  // margin-top: 1rem;\n  border-radius: 60px;\n\n  font-weight: ", ";\n  background: rgba(0,0,0,0.1);\n  border: solid 0.3em #FFFFFF;\n  box-shadow: none;\n\n  &:hover {\n  }\n"])), function (props) {
  return props.textScale || 1;
}, function (props) {
  return props.textBold === false ? 400 : 700;
});
var Preview = _styledComponents.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border-radius: 2em;\n  overflow: hidden;\n  border: none;\n  margin: '0 auto';\n  border-radius: '36px';\n"])));
var PreviewWrapper = _styledComponents.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\nposition: absolute;\nbottom: 3%;\npadding: 1em;\nwidth: 70%;\nmargin-left: -1em;\nleft: 15%;\nheight: 70%;\n// background: white;\ndisplay: flex;\nflex-direction: column;\nalign-items: center;\njustify-content: space-between;\n/* Enforce portrait aspect ratio */\n/* margin: 20px auto; Removed margin as fixed positioning handles placement */\n// box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.1);\nz-index: 100; /* Ensure it's above other content */\n"])));
var ImageContainer = _styledComponents.default.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: calc(100% - 60px);\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius : 16px;\n\n  img {\n    max-width: 100%;\n    max-height: 100%;\n    // object-fit: contain; /* Preserve aspect ratio and fit inside the frame */\n    overflow: hidden;\n  }\n"])));
var ShareOptionsContainer = _styledComponents.default.div(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  position: absolute;\n  /* calc() so share_controls_offset shifts this ON TOP OF the format's base value \u2014 replacing it would\n     silently drop the square/portrait distinction. Same offset feeds ButtonGroup, so the two blocks\n     move together and keep their spacing. */\n  top: calc(", " + ", "%);\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 0;\n  width: 100%;\n  max-width: 1080px;\n  z-index: 10;\n  padding: 0 1rem;\n  box-sizing: border-box;\n"])), function (props) {
  return props.square ? '18%' : '10%';
}, function (props) {
  return props.offset != null ? props.offset : 0;
});

// The transparent window of the frame, as a share of the full 9:16 canvas. Measured from the Chanel
// "Crush Absolu" asset; these are the knobs to tune if a future frame crops its window differently.
// Shared by the live feed (WindowedCamera) and the reveal photo (WindowedPhoto) so the two steps line
// up exactly. Declared at the top: the styled-components below close over it at module scope, so a
// later `const` would be a temporal-dead-zone crash on import.
var REVEAL_WINDOW = {
  top: '20.5%',
  left: '6%',
  width: '88%',
  height: '74%'
};

// REVEAL_WINDOW resolved against a w x h canvas, so the emailed/QR composition and the DOM boxes read
// the window from the same four numbers — the whole point of the constant.
var windowRect = function windowRect(w, h) {
  var pct = function pct(v) {
    return parseFloat(v) / 100;
  };
  return {
    wx: Math.round(pct(REVEAL_WINDOW.left) * w),
    wy: Math.round(pct(REVEAL_WINDOW.top) * h),
    ww: Math.round(pct(REVEAL_WINDOW.width) * w),
    wh: Math.round(pct(REVEAL_WINDOW.height) * h)
  };
};

// Photo reveal (fullscreen_reveal mode). `absolute` inside Container — not `fixed` — so it stays
// inside the cell box in the front editor preview.
// The reveal must look EXACTLY like the live camera step: the 2:3 photo sits in the frame's
// transparent window (REVEAL_WINDOW, same box as WindowedCamera) with the 9:16 frame full-screen over
// it. Stretching the 2:3 photo across the whole 9:16 screen is what made it look zoomed in.
var FullscreenPhoto = _styledComponents.default.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  position: absolute;\n  inset: 0;\n  z-index: 200;\n"])));

// The photo, in the frame's window. `fill` (not cover/contain) to exactly match PreviewCanvas in the
// live step — the canvas is drawn at the same 2:3 aspect, so fill introduces no distortion and
// guarantees the two steps line up pixel for pixel.
var WindowedPhoto = _styledComponents.default.img(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", ";\n  left: ", ";\n  width: ", ";\n  height: ", ";\n  object-fit: fill;\n  /* Sits above the live feed (PreviewCanvas, z-index 2) and below the frame (z-index 50), so the photo\n     can be painted over the still-running feed before the step changes. */\n  z-index: 3;\n  /* Mounted hidden and flipped on the img's own onLoad: a data-URL src is not guaranteed to be decoded\n     by the first paint, so showing it immediately would reproduce the flash in a new place. */\n  opacity: ", ";\n  transition: opacity 120ms ease;\n"])), REVEAL_WINDOW.top, REVEAL_WINDOW.left, REVEAL_WINDOW.width, REVEAL_WINDOW.height, function (props) {
  return props.visible ? 1 : 0;
});

// Same photo, but rendered INSIDE WindowedCamera (which already is the frame's window) during the
// capture→reveal overlap — so it fills its parent rather than re-applying the window offsets, which
// would double them. Identical z-index/fade behaviour to WindowedPhoto.
var InBoxPhoto = _styledComponents.default.img(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: fill;\n  z-index: 3;\n  opacity: ", ";\n  transition: opacity 120ms ease;\n"])), function (props) {
  return props.visible ? 1 : 0;
});

// Centered column share layout (fullscreen_reveal mode): retake, QR, print stacked. Replaces
// Preview + ShareOptionsContainer + ButtonGroup; the cards inside are reused verbatim.
var ShareColumn = _styledComponents.default.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ", "px;\n  width: 100%;\n  z-index: 100;\n"])), function (props) {
  return props.gap;
});

// Invisible upper-left tap zone linking to the admin's "Lien vers" page (links_to_page_id). Used by
// BOTH share layouts, so the z-index has to clear the topmost block of each: the column layout's
// ShareColumn (100, width:100% and vertically centered) and the classic layout's ButtonGroup (100,
// width:100% near the top) — either bounding box covers this corner and would swallow the tap.
var CORNER_LINK_STYLE = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '20%',
  height: '20%',
  zIndex: 101
};

// Fills the <a> that linkFromPageId wraps around it. The geometry lives on the anchor (passed as
// linkFromPageId's third param) — repeating 20% here would resolve against the anchor, giving a
// 4% inner box.
var CornerLink = _styledComponents.default.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n"])));

// Project-level button shape (Project settings -> Global buttons definition) as a border-radius.
// The photobooth's own buttons are plain styled-components, so they don't go through ButtonCell's
// shape() helper — this maps the same `default_button_shape` values onto them. `circle` needs the
// cell's width/height ratio (see ButtonCell.shape) which doesn't apply to a fixed-width button here,
// so it falls back to fully rounded.
var buttonRadius = function buttonRadius(project) {
  switch (project && project.default_button_shape) {
    case 'rectangle':
      return '0';
    case 'rounded_rectangle':
      return '1em';
    case 'circle':
      return '50%';
    default:
      return '60px';
  }
};

// Groups the optional print title with the print button so they stay one unit in the column's
// flex layout (the ShareColumn gap would otherwise space them like two separate items).
var PrintGroup = _styledComponents.default.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));

// Shared geometry for the column layout's two buttons (retake + print) so they are the same box.
// PrintButton is 78.75px tall inside a 240px-wide card; SecondaryButton is 15rem wide with its own
// padding, so without this the two read as different-sized buttons.
// A FIXED width, not min-width: the two labels differ in length ("REPRENDRE LA PHOTO" vs "ICI"), so
// a min-width let the long one grow past the short one and the buttons read as mismatched boxes.
// 520px is sized for the longest label plus the 3em side padding — the earlier 240px overflow
// happened because that fixed width was narrower than the label itself, not because it was fixed.
var COLUMN_BUTTON = {
  width: '520px',
  height: '78.75px',
  padding: '0 3em'
};

// The print card's colour once it has been tapped — both the press itself and the spent (printed)
// state that follows. A flat mid grey, not a transparency: white labels and icons still read on it,
// and it is unmistakably a state change whatever button_print_background_color the admin picked.
// Both share layouts use it, so the booth behaves the same either way.
var PRINT_TAPPED_GREY = '#808080';

// Compact print card for the column layout: no printer icon, so the shared card's 235px min-height
// would leave a tall empty block instead of the flat bar the design calls for.
var ColumnPrintCard = _styledComponents.default.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  /* Matches the retake button exactly: same fixed width regardless of label length. */\n  width: ", ";\n  height: ", ";\n  padding: ", ";\n  white-space: nowrap;\n  min-height: 0;\n  border-radius: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-sizing: border-box;\n  transition: filter 0.15s ease;\n\n  /* Tapping turns the card GREY rather than fading it. A tap used to drop it to 60% opacity and leave\n     it there (the button is disabled once printed), which washed the label out along with the\n     background and read as \"broken\" rather than \"done\".\n     !important because the card's background is an inline style (the admin's\n     button_print_background_color), and an inline style beats any class rule without it. */\n  &:active {\n    background: ", " !important;\n  }\n\n  ", "\n"])), COLUMN_BUTTON.width, COLUMN_BUTTON.height, COLUMN_BUTTON.padding, PRINT_TAPPED_GREY, function (props) {
  return props.disabled && "\n    cursor: not-allowed;\n  ";
});

// Admin-configured link button under the print button. Same box as retake and print by reusing
// COLUMN_BUTTON, so the three stay identical by construction.
// A div, NOT SecondaryButton: that is a styled.button (ActionButton), and linkFromPageId wraps its
// children in a react-router <Link> — a <button> inside an <a> is invalid HTML and clicks behave
// inconsistently across browsers. ColumnPrintCard/PrintButton use the same div-in-div shape.
var ColumnLinkCard = _styledComponents.default.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  padding: ", ";\n  white-space: nowrap;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: calc(23px * var(--text-scale, 1));\n  font-weight: 700;\n  text-decoration: none;\n"])), COLUMN_BUTTON.width, COLUMN_BUTTON.height, COLUMN_BUTTON.padding);

/* "Change background" button on the live camera step — same look as the OBS photobooth's (green
   glossy pill, thick white outline). It is a link to another project page (the filters page). It is
   portaled to <body> (see render) so no ancestor overflow-clip or grid transform shifts it:
   position: fixed then makes change_bg_button_position a straight % of screen height from the top. */
var ChangeBgBar = _styledComponents.default.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  position: fixed;\n  left: 0;\n  width: 100%;\n  z-index: 6000;\n  pointer-events: none;\n"])));
var ChangeBgButton = _styledComponents.default.div(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  pointer-events: auto;\n  width: 15rem;\n  box-sizing: border-box;\n  padding: 16px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: calc(1.2rem * var(--text-scale, 1));\n  font-weight: bold;\n  color: #FFFFFF;\n  border: solid 0.28em #FFFFFF;\n  border-radius: 999px;\n  background:\n    linear-gradient(180deg, rgba(255,255,255,0.45) 0%, rgba(255,255,255,0) 55%),\n    linear-gradient(180deg, #3AAA35 0%, #008332 100%);\n  box-shadow: 0 4px 10px rgba(0,0,0,0.25);\n  text-shadow: 0 1px 2px rgba(0,0,0,0.25);\n"])));
var EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
var SEND_ERROR_TEXTS = {
  fr: {
    invalidEmail: 'Adresse email invalide',
    failed: "L'envoi a échoué, réessayez"
  },
  en: {
    invalidEmail: 'Invalid email address',
    failed: 'Sending failed, please try again'
  },
  nl: {
    invalidEmail: 'Ongeldig e-mailadres',
    failed: 'Verzenden mislukt, probeer opnieuw'
  },
  de: {
    invalidEmail: 'Ungültige E-Mail-Adresse',
    failed: 'Senden fehlgeschlagen, bitte erneut versuchen'
  },
  es: {
    invalidEmail: 'Dirección de correo no válida',
    failed: 'Error al enviar, inténtalo de nuevo'
  }
};
var sendErrorTexts = function sendErrorTexts(locale) {
  return SEND_ERROR_TEXTS[locale] || SEND_ERROR_TEXTS.en;
};
var ShareOptionCard = _styledComponents.default.div(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0;\n  border-radius: 20px;\n  backdrop-filter: blur(100px);\n  -webkit-backdrop-filter: blur(100px);\n  min-height: 235px;\n  position: relative;\n  box-sizing: border-box;\n"])));
var EmailCard = (0, _styledComponents.default)(ShareOptionCard)(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  background: rgba(122, 103, 66, 0.2);\n  width: 301px;\n  margin-right: 30px;\n"])));
var QRCodeCard = (0, _styledComponents.default)(ShareOptionCard)(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  background: rgba(122, 103, 66, 0.2);\n  width: 240px;\n  margin-right: 31px;\n"])));
var PrintCard = (0, _styledComponents.default)(ShareOptionCard)(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  width: 240px;\n  cursor: pointer;\n  transition: filter 0.15s ease;\n\n  /* Same press feedback as the column layout's ColumnPrintCard: the whole card is the tap target here\n     (the onClick is on the card, not the label), so this is what the user actually sees. */\n  &:active {\n    background: ", " !important;\n  }\n"])), PRINT_TAPPED_GREY);
var CardTitle = _styledComponents.default.h3(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  font-family: inherit;\n  font-size: calc(18px * var(--text-scale, 1));\n  font-weight: ", ";\n  text-align: center;\n  margin: 10px 0 0 0;\n  padding: 0;\n  color: ", ";\n  line-height: 1.2;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), function (props) {
  return props.textBold === false ? 400 : 700;
}, function (props) {
  return props.color || '#7A6742';
});
var EmailInput = _styledComponents.default.div(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  width: 240px;\n  height: 36px;\n  min-height: 36px;\n  flex-shrink: 0;\n  padding: 0;\n  border-radius: 100px;\n  background: rgba(255, 255, 255, 0.7);\n  font-family: inherit;\n  font-size: calc(15px * var(--text-scale, 1));\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n  color: rgba(122, 103, 66, 0.5);\n  cursor: pointer;\n  margin: 12px 0 12px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n"])));
var SendButton = _styledComponents.default.button(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  width: 120px;\n  height: 36px;\n  padding: 0;\n  border-radius: 100px;\n  color: #FFFFFF;\n  font-family: inherit;\n  font-size: calc(18px * var(--text-scale, 1));\n  font-weight: 700;\n  text-transform: uppercase;\n  border: none;\n  cursor: pointer;\n  transition: opacity 0.2s;\n  box-sizing: border-box;\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  &:hover:not(:disabled) {\n    opacity: 0.9;\n  }\n"])));
var QRCodeDisplay = _styledComponents.default.div(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 120px;\n  height: 120px;\n  margin: 0px auto 35px auto;\n"])));
var PrintIconContainer = _styledComponents.default.div(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100px;\n  height: 97px;\n  margin: 32px auto 0 auto;\n"])));
var PrintButton = _styledComponents.default.div(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 78.75px;\n  padding: 0;\n  text-align: center;\n  font-family: inherit;\n  font-size: calc(23px * var(--text-scale, 1) * ", ");\n  font-weight: ", ";\n  color: #FFFFFF;\n  cursor: pointer;\n  transition: filter 0.15s ease;\n  margin-top: 1.5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n\n  /* No press/hover styling of its own: this is the LABEL inside the card, and the card is the tap\n     target that carries the onClick \u2014 its :active already covers the label. A filter here would\n     compound with the card's (1.35 x 1.35) on the one element that must stay legible.\n     Hover is deliberately not styled either: on a kiosk touchscreen a tap sets hover and it STICKS\n     until the next tap elsewhere, so the old hover rule (opacity 0.9) left the button permanently\n     dimmed after being used \u2014 the opposite of feedback. */\n  ", "\n"])), function (props) {
  return props.textScale || 1;
}, function (props) {
  return props.textBold === false ? 400 : 700;
}, function (props) {
  return props.disabled && "\n    cursor: not-allowed;\n  ";
});
var ShareFormContainer = _styledComponents.default.div(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 65%;\n  flex-direction: column;\n  align-items: center;\n  padding: 1rem;\n  z-index: 10;\n  border-radius: 24px;\n  background:rgb(255, 255, 255, 0.2);\n  opacity: 0.4;\n  backdrop-filter: blur(20px);\n"])));
var ShareContent = _styledComponents.default.div(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1fr 10rem;\n  gap: 0.5rem;\n  align-items: start;\n"])));
var FormTitle = _styledComponents.default.h2(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  font-family: inherit;\n  font-size: calc(0.9rem * var(--text-scale, 1));\n  font-weight: 500;\n  margin: 1rem 0;\n  text-align: center;\n  width: 100%;\n  font-weight: bold;\n  font-family: inherit;\n  color : #fff;\n"])));
var QRCodeWrapper = _styledComponents.default.div(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  margin-left: 3rem;\n  background: white;\n  padding: 0.5rem;\n  border-radius: 0.8rem;\n  width: 5rem;\n"])));
var PreviewWrapper2 = _styledComponents.default.div(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 50%;\n  /* calc() so share_preview_offset lifts this ON TOP OF the format's base anchor \u2014 replacing it would\n     drop the square format's 12%. Anchored on bottom, so a larger offset moves the preview UP. */\n  bottom: calc(", " + ", "%);\n  transform: translateX(-50%);\n  /* Admin-configurable (share_preview_width); 73% is the historical fixed value. */\n  width: ", "%;\n  padding: 1em;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  z-index: 100;\n"])), function (props) {
  return props.square ? '12%' : '0%';
}, function (props) {
  return props.offset != null ? props.offset : 0;
}, function (props) {
  return props.previewWidth != null ? props.previewWidth : 73;
});
var ShareInput = _styledComponents.default.div(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n  padding: 0.7rem 1rem;\n  border-radius: 2rem;\n  font-size: calc(1rem * var(--text-scale, 1));\n  font-family: inherit;\n  outline: none;\n  border: none;\n  background: #FFFFFF;\n  border: 0.1rem solid #000000;\n  &:focus {\n  }\n"])));
var ShareCheckbox = _styledComponents.default.label(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n  font-family: inherit;\n  font-size: calc(0.8rem * var(--text-scale, 1));\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  line-height: 1.4;\n\n  input {\n    width: 1rem;\n    height: 1rem;\n\n  }\n  input[type=\"checkbox\"]:checked {\n  background-color: #333;\n}\n"])));
var BackgroundWrapper = _styledComponents.default.div(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n  background-size: cover;\n  background: rgba(0,0,0,0);\n  background-position: center;\n  width: 100%;\n  height: 100%;\n"])));
var ShareButton = (0, _styledComponents.default)(ActionButton)(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n  margin: 0;\n  width: 40%;\n  border-radius: 2rem;\n  font-size: calc(1rem * var(--text-scale, 1));\n  padding: 0.5rem;\n  text-transform: none;\n  background: #FFFFFF;\n  box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.25);\n  backdrop-filter: blur(12.5px);\n\n  &:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n  }\n"])));
var LogoImage = _styledComponents.default.img(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n  height: auto;\n  width: 30%;\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n"])));
var LogoImage2 = _styledComponents.default.img(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n  height: auto;\n  width: 90%;\n  margin-top: 0.7rem;\n"])));
var ShareForm = _styledComponents.default.form(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n"])));
var CameraContainer = _styledComponents.default.div(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n  height: 100%;\n  width: 100%;\n\n  position: relative;\n  border-radius: 0px;\n  overflow: hidden;\n\n  box-sizing: border-box;\n  background: ", "; /* Loading backdrop: admin-configurable, transparent by default */\n  /* Both formats center their inner box so the live feed has borders around it\n     (square = 1:1; portrait = the 15x10 box sized in Camera). */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), function (props) {
  return props.cameraReady ? 'transparent' : props.loaderBg || 'transparent';
});
var Camera = _styledComponents.default.div(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n  position: relative;\n  /* Square mode: a centered 1:1 box. Width-driven (matches the share-preview box) so the\n     square side derives from width on a portrait kiosk; max-height guards a landscape cell.\n     Width < 100% leaves horizontal padding so the preview doesn't touch the screen edges.\n     Centered by CameraContainer's flexbox. */\n  ", "\n"])), function (props) {
  return props.square ? "\n    width: 90%;\n    height: auto;\n    aspect-ratio: 1 / 1;\n    max-height: 100%;\n    overflow: hidden;\n  " : "\n    /* Portrait (15x10) mode: a centered 2:3 box slightly inset from the screen so there are\n       borders around the live feed. Height-driven (kiosk is taller than the 2:3 photo) with a\n       width guard; both < 100% leave the surrounding margin. Centered by CameraContainer. */\n    width: auto;\n    height: 92%;\n    aspect-ratio: 2 / 3;\n    max-width: 92%;\n    overflow: hidden;\n  ";
});
var VideoPreview = _styledComponents.default.video(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n  width: 110%;\n  height: 100%;\n  /* Center the 110%-wide element horizontally; tune this value on the booth if it drifts. */\n  margin-left: -2.5%;\n  object-fit: contain;\n  /* Rotate 90\xB0 and scale to match captured photo field of view (4:6 crop from rotated video) */\n  /* Square mode shows the centered 1:1 crop; scale(1.78) is a starting value \u2014 tune on the booth. */\n  transform: ", ";\n  transform-origin: center center;\n  border-radius: 2.2em;\n"])), function (props) {
  return props.square ? props.mirror ? 'scaleX(-1) rotate(90deg) scale(1.78)' : 'rotate(90deg) scale(1.78)' : props.mirror ? 'scaleX(-1) rotate(90deg) scale(1.57) translateY(-10px)' : 'rotate(90deg) scale(1.57)';
});

// Visible live preview. The canvas content is already cropped + rotated upright by the draw loop
// (same pipeline as the capture), so it needs NO CSS rotation — only the mirror, kept to match the
// previous selfie-style preview. object-fit: fill makes it cover the same box as the frame overlay
// (GifOverlay, also fill), so frame + photo line up exactly as they do in the final image.
var PreviewCanvas = _styledComponents.default.canvas(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: fill;\n  transform: ", ";\n  transform-origin: center center;\n  /* No border-radius: the canvas covers the full rectangle so the raw video behind never\n     peeks through rounded corners, and it matches the flat rectangular final image. */\n  z-index: 2;\n  pointer-events: none;\n"])), function (props) {
  return props.mirror ? 'scaleX(-1)' : 'none';
});

// COMMENTED OUT: Frozen frame feature (may be needed later)
// const FrozenFrame = styled.img`
//   width: 100%;
//   height: 100%;
//   object-fit: cover;
//   /* Rotate 90° and scale to fill container (scale by container aspect ratio to compensate for rotation) */
//   transform: scaleX(-1) rotate(90deg) scale(1.57); // Mirror effect + 90° rotation like video
//   transform-origin: center center;
//   border-radius: 2.2em;
//   position: absolute;
//   top: 0;
//   left: 0;
//   z-index: 1;
// `;

// const ProcessingOverlay = styled.div`
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   background: rgba(0, 0, 0, 0.3);
//   backdrop-filter: blur(2px);
//   z-index: 100;
//   border-radius: 2.2em;
// `;

// const ProcessingMessage = styled.div`
//   font-family: 'Helvetica Neue', sans-serif;
//   font-size: 1.5rem;
//   font-weight: 600;
//   color: white;
//   text-align: center;
//   padding: 1rem 2rem;
//   background: rgba(0, 0, 0, 0.6);
//   border-radius: 1rem;
//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
//   backdrop-filter: blur(10px);
// `;

var CountdownOverlay = _styledComponents.default.div(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 4rem;\n  height: 4rem;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: rgba(255, 255, 255, 0.5);\n  box-shadow: 10px 15px 30px rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3;\n"])));
var CountdownNumber = _styledComponents.default.div(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["\n  font-family: inherit;\n  font-size: calc(1.8rem * var(--text-scale, 1));\n  font-weight: 700;\n  line-height: 1;\n"])));

// Progress bar container: Shows below camera loader when photo is being processed
var ProgressBarContainer = _styledComponents.default.div(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%; /* Positioned just below camera loader circle (at 50%) */\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 60%;\n  max-width: 20rem;\n  z-index: 100; /* Higher than GifOverlay (z-index: 50) and CountdownOverlay (z-index: 3) */\n"])));
var ProgressBarWrapper = _styledComponents.default.div(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 0.5rem;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 0.5rem;\n  overflow: hidden;\n  margin-top: 15px;\n  position: relative;\n"])));
var ProgressBarFill = _styledComponents.default.div(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["\n  height: 100%;\n  width: ", "%;\n  background: #fff;\n  background-size: 1rem 1rem;\n  animation: progressAnimation 0.5s linear infinite;\n  transition: width 0.3s ease-out;\n\n  @keyframes progressAnimation {\n    0% {\n      background-position: 0 0;\n    }\n    100% {\n      background-position: 1rem 1rem;\n    }\n  }\n"])), function (props) {
  return props.progress;
});
var ProgressText = _styledComponents.default.div(_templateObject51 || (_templateObject51 = _taggedTemplateLiteral(["\n  margin-top: 0.5rem;\n  text-align: center;\n  font-family: inherit;\n  font-size: calc(1rem * var(--text-scale, 1));\n  font-weight: 600;\n  color: white;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);\n  /* fullscreen_reveal layout only: the progress phrases are uppercase there. Presentational, so it is\n     text-transform rather than forcing the admin to type the text in caps. */\n  ", "\n"])), function (props) {
  return props.uppercase && 'text-transform: uppercase;';
});
var GifOverlay = _styledComponents.default.img(_templateObject52 || (_templateObject52 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: fill;\n  z-index: 50;\n  pointer-events: none;\n"])));

// fullscreen_reveal mode only: the frame is a full-screen 9:16 asset (e.g. 1080x1920) whose
// transparent window holds the feed. So the frame is pinned to the whole cell — NOT to the inset 2:3
// Camera box, which would squash a 9:16 asset — and the camera box is positioned into the window.
// `contain` keeps the frame undistorted if the screen is not exactly 9:16.
var FullscreenGifOverlay = _styledComponents.default.img(_templateObject53 || (_templateObject53 = _taggedTemplateLiteral(["\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  z-index: 50;\n  pointer-events: none;\n"])));

// fullscreen_reveal mode only: the live feed box, absolutely placed inside the frame's window instead
// of being centered by CameraContainer's flexbox.
var WindowedCamera = _styledComponents.default.div(_templateObject54 || (_templateObject54 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", ";\n  left: ", ";\n  width: ", ";\n  height: ", ";\n  overflow: hidden;\n"])), REVEAL_WINDOW.top, REVEAL_WINDOW.left, REVEAL_WINDOW.width, REVEAL_WINDOW.height);

// Picks the feed box for the active layout. forwardRef because useBoxHeight measures it to size the
// user-info overlay text.
var CameraBox = /*#__PURE__*/_react.default.forwardRef(function (_ref5, ref) {
  var windowed = _ref5.windowed,
    props = _objectWithoutProperties(_ref5, _excluded);
  return windowed ? /*#__PURE__*/_react.default.createElement(WindowedCamera, _extends({
    ref: ref
  }, props)) : /*#__PURE__*/_react.default.createElement(Camera, _extends({
    ref: ref
  }, props));
});

// COMMENTED OUT: Flash animation feature (may be needed later)
// Flash overlay: Full-screen white flash animation that appears when photo is taken
// Shows for 500ms to simulate camera flash effect
// const FlashOverlay = styled.div`
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100vw;
//   height: 100vh;
//   background-color: white;
//   z-index: 10000; // High z-index to cover everything
//   pointer-events: none; // Don't block user interactions
//   opacity: ${props => props.show ? 1 : 0};
//   transition: opacity 0.1s ease-out; // Smooth fade transition
// `;

var ControlBar = _styledComponents.default.div(_templateObject55 || (_templateObject55 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* center items horizontally */\n  justify-content: center;\n  position: absolute;\n  z-index: 60;\n  /* Default layout: the historical fixed offset, measured from the bottom of the whole cell.\n     fullscreen_reveal: centred inside the frame's transparent window (REVEAL_WINDOW) instead, so the\n     prompt sits in the middle of the visible camera preview rather than above it. */\n  ", "\n"])), function (props) {
  return props.windowed ? "\n    top: ".concat(REVEAL_WINDOW.top, ";\n    left: ").concat(REVEAL_WINDOW.left, ";\n    width: ").concat(REVEAL_WINDOW.width, ";\n    height: ").concat(REVEAL_WINDOW.height, ";\n    /* The bar now spans the whole window above the frame (z 50), so it would swallow taps aimed at the\n       preview. Ignore pointer events on the box and re-enable them on the button itself, which is also\n       the larger, easier target the \"touch to start\" prompt implies. */\n    pointer-events: none;\n    & > * { pointer-events: auto; }\n  ") : "\n    bottom: 65%;\n    width: 100%;\n  ";
});
var CameraButton = _styledComponents.default.div(_templateObject56 || (_templateObject56 = _taggedTemplateLiteral(["\n    padding: 0;\n    background: none;\n    border: none;\n    border-radius: 0;\n    box-shadow: none;\n    backdrop-filter: none;\n    -webkit-backdrop-filter: none;\n    cursor: pointer;\n\n"])));
var ButtonText = _styledComponents.default.div(_templateObject57 || (_templateObject57 = _taggedTemplateLiteral(["\n  font-family: inherit;\n  font-size: calc(1.2em * var(--text-scale, 1));\n  font-weight: 500;\n  letter-spacing: 1px;\n  margin-top: 1rem;\n  animation: ", " 1.2s ease-in-out infinite;\n"])), pulse);

// Measure a box's pixel height and keep it current across resizes. Used to size the user-info
// overlay text relative to the box height — the same basis the baked canvas uses (fraction of h).
// Returns [callbackRef, height]. A callback ref (not a plain ref) is required because the measured
// box (the live Camera) is rendered conditionally on a later step: a plain
// ref + effect would run once at mount when the node doesn't exist yet and never re-measure. The
// callback ref fires the moment the node attaches, so we measure and observe it then.
var useBoxHeight = function useBoxHeight() {
  var _ref6 = (0, _react.useState)(0),
    _ref7 = _slicedToArray(_ref6, 2),
    h = _ref7[0],
    setH = _ref7[1];
  var roRef = (0, _react.useRef)(null);
  var setRef = _react.default.useCallback(function (el) {
    if (roRef.current) {
      roRef.current.disconnect();
      roRef.current = null;
    }
    if (!el) return;
    setH(el.clientHeight);
    var ro = new ResizeObserver(function () {
      return setH(el.clientHeight);
    });
    ro.observe(el);
    roRef.current = ro;
  }, []);
  return [setRef, h];
};

// User-info text (first name + bold SURNAME + birthdate) rendered as a DOM overlay over the live
// preview AND the share preview. Reproduces the baked drawUserInfo exactly so what the user sees
// matches the downloaded/printed image:
//   - font size = fraction of the box HEIGHT (0.042 name / 0.031 date), same constants as the canvas
//   - the NAME's vertical center is anchored at posPct from the bottom (canvas uses textBaseline:'middle')
//   - the date sits below the name by nameFont*0.95 (canvas: dateY = nameY + nameSize*0.95)
//   - horizontal center at hPosPct (canvas: centerX = w*hPosPct)
// boxH is measured by the caller (useBoxHeight) so this component stays pure.
var UserInfoOverlay = function UserInfoOverlay(_ref8) {
  var boxH = _ref8.boxH,
    sizeScale = _ref8.sizeScale,
    posPct = _ref8.posPct,
    hPosPct = _ref8.hPosPct,
    color = _ref8.color,
    font = _ref8.font,
    firstName = _ref8.firstName,
    surname = _ref8.surname,
    birthdate = _ref8.birthdate;
  if (!boxH) return null; // avoid a flash of 0px text before the ResizeObserver fires
  var nameFont = 0.042 * sizeScale * boxH; // == canvas nameSize
  var dateFont = 0.031 * sizeScale * boxH; // == canvas dateSize
  var first = (firstName || '').trim();
  var last = (surname || '').trim().toUpperCase();
  var date = (birthdate || '').trim();
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'absolute',
      left: "".concat(hPosPct * 100, "%"),
      bottom: "".concat(posPct * 100, "%"),
      transform: 'translate(-50%, 50%)',
      // center on the bottom:posPct line == textBaseline:'middle'
      whiteSpace: 'nowrap',
      textAlign: 'center',
      pointerEvents: 'none',
      zIndex: 10,
      color: color || '#fff',
      fontFamily: font || 'Arial',
      lineHeight: 1
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontSize: "".concat(nameFont, "px"),
      position: 'relative'
    }
  }, first, first && last ? ' ' : '', /*#__PURE__*/_react.default.createElement("strong", {
    style: {
      fontWeight: 900
    }
  }, last), date && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: "translate(-50%, calc(-50% + ".concat(nameFont * 0.95, "px))"),
      // == canvas dateY = nameY + nameSize*0.95
      fontSize: "".concat(dateFont, "px"),
      lineHeight: 1,
      whiteSpace: 'nowrap'
    }
  }, date)));
};
function PhotoboothGifCell(_ref9) {
  var cell = _ref9.cell,
    pageId = _ref9.pageId,
    screenType = _ref9.screenType,
    _ref9$uriTransformer = _ref9.uriTransformer,
    uriTransformer = _ref9$uriTransformer === void 0 ? function (u) {
      return u;
    } : _ref9$uriTransformer,
    project = _ref9.project,
    intl = _ref9.intl,
    defaultLanguage = _ref9.defaultLanguage,
    linkFromPageId = _ref9.linkFromPageId;
  var _ref0 = (0, _react.useState)(''),
    _ref1 = _slicedToArray(_ref0, 2),
    email = _ref1[0],
    setEmail = _ref1[1];
  var _ref10 = (0, _react.useState)({}),
    _ref11 = _slicedToArray(_ref10, 2),
    textDatas = _ref11[0],
    setTextDatas = _ref11[1];
  var _ref12 = (0, _react.useState)(false),
    _ref13 = _slicedToArray(_ref12, 2),
    consent = _ref13[0],
    setConsent = _ref13[1];
  var _ref14 = (0, _react.useState)(true),
    _ref15 = _slicedToArray(_ref14, 2),
    terms = _ref15[0],
    setTerms = _ref15[1];
  var _ref16 = (0, _react.useState)(''),
    _ref17 = _slicedToArray(_ref16, 2),
    link = _ref17[0],
    setLink = _ref17[1];
  var _ref18 = (0, _react.useState)(false),
    _ref19 = _slicedToArray(_ref18, 2),
    isSending = _ref19[0],
    setIsSending = _ref19[1];
  var _ref20 = (0, _react.useState)(null),
    _ref21 = _slicedToArray(_ref20, 2),
    sendStatus = _ref21[0],
    setSendStatus = _ref21[1];
  var _ref22 = (0, _react.useState)(cell.collect_user_info ? 'info' : 'camera'),
    _ref23 = _slicedToArray(_ref22, 2),
    step = _ref23[0],
    setStep = _ref23[1];
  var _ref24 = (0, _react.useState)(null),
    _ref25 = _slicedToArray(_ref24, 2),
    capturedImage = _ref25[0],
    setCapturedImage = _ref25[1];
  // Per-session end-user info (NOT persisted) — entered on the 'info' step, baked into the canvas.
  var _ref26 = (0, _react.useState)(''),
    _ref27 = _slicedToArray(_ref26, 2),
    userFirstName = _ref27[0],
    setUserFirstName = _ref27[1];
  var _ref28 = (0, _react.useState)(''),
    _ref29 = _slicedToArray(_ref28, 2),
    userSurname = _ref29[0],
    setUserSurname = _ref29[1];
  var _ref30 = (0, _react.useState)(''),
    _ref31 = _slicedToArray(_ref30, 2),
    userBirthdate = _ref31[0],
    setUserBirthdate = _ref31[1];
  var _ref32 = (0, _react.useState)(null),
    _ref33 = _slicedToArray(_ref32, 2),
    activeInfoField = _ref33[0],
    setActiveInfoField = _ref33[1]; // which field the on-screen keyboard edits
  // Birthdate setter that forces dd-mm-yyyy. AzertyKeyboard always passes a functional updater
  // (v => v + key / v => v.slice(0,-1)); we recompute the mask from whatever digits remain.
  var setBirthdateMasked = function setBirthdateMasked(updater) {
    return setUserBirthdate(function (prev) {
      var raw = typeof updater === 'function' ? updater(prev) : updater;
      var d = (String(raw).match(/\d/g) || []).join('').slice(0, 8);
      return d.slice(0, 2) + (d.length > 2 ? '-' + d.slice(2, 4) : '') + (d.length > 4 ? '-' + d.slice(4, 8) : '');
    });
  };
  // Initial value is a placeholder; the real start value (photoTimer + LEAD_IN) is set in
  // startCountdown before the 'countdown' step ever renders.
  var _ref34 = (0, _react.useState)(0),
    _ref35 = _slicedToArray(_ref34, 2),
    countdown = _ref35[0],
    setCountdown = _ref35[1];
  var streamRef = (0, _react.useRef)(null);
  var previewCanvasRef = (0, _react.useRef)(null);
  var animationFrameId = (0, _react.useRef)(null);
  // Background replacement (MediaPipe Selfie Segmentation)
  var selfieSegmentationRef = (0, _react.useRef)(null);
  var segmentationMaskRef = (0, _react.useRef)(null);
  var backgroundImageRef = (0, _react.useRef)(null);
  var segLoopRef = (0, _react.useRef)(null);
  var liveSceneRef = (0, _react.useRef)(null); // Offscreen canvas: composited (background-replaced) feed in raw-frame space
  var displayCanvasRef = (0, _react.useRef)(null); // Visible preview canvas: runs the SAME crop+rotate as capture (upright, no CSS rotation)
  var previewLoopRef = (0, _react.useRef)(null); // rAF id for the visible-preview draw loop
  var uprightInputRef = (0, _react.useRef)(null); // Offscreen canvas: raw frame rotated upright for the segmenter
  var rawMaskCanvasRef = (0, _react.useRef)(null); // Offscreen canvas: segmentation mask rotated back to raw-frame space
  var _ref36 = (0, _react.useState)(false),
    _ref37 = _slicedToArray(_ref36, 2),
    hasCamera = _ref37[0],
    setHasCamera = _ref37[1];
  var _ref38 = (0, _react.useState)(null),
    _ref39 = _slicedToArray(_ref38, 2),
    cameraError = _ref39[0],
    setCameraError = _ref39[1];
  var videoRef = (0, _react.useRef)(null);
  var cameraContainerRef = (0, _react.useRef)(null);
  // Callback refs + measured heights for the boxes that hold the user-info overlay, so its text can
  // be sized off their pixel height (mirroring the canvas bake). Live = the Camera box, which IS the
  // frame's window in fullscreen mode and therefore the whole photo. It mounts conditionally on a later
  // step, so a callback ref is required (see useBoxHeight) to measure it once it appears.
  var _useBoxHeight = useBoxHeight(),
    _useBoxHeight2 = _slicedToArray(_useBoxHeight, 2),
    cameraBoxRef = _useBoxHeight2[0],
    cameraBoxH = _useBoxHeight2[1];
  var progressIntervalRef = (0, _react.useRef)(null); // Store progress interval reference
  var _ref40 = (0, _react.useState)(false),
    _ref41 = _slicedToArray(_ref40, 2),
    keyboardVisible = _ref41[0],
    setKeyboardVisible = _ref41[1];
  var _ref42 = (0, _react.useState)(false),
    _ref43 = _slicedToArray(_ref42, 2),
    isSended = _ref43[0],
    setIsSended = _ref43[1];
  var _ref44 = (0, _react.useState)(false),
    _ref45 = _slicedToArray(_ref44, 2),
    printed = _ref45[0],
    setPrinted = _ref45[1];
  var _ref46 = (0, _react.useState)(null),
    _ref47 = _slicedToArray(_ref46, 2),
    imageUrl = _ref47[0],
    setImageUrl = _ref47[1];
  var _ref48 = (0, _react.useState)(''),
    _ref49 = _slicedToArray(_ref48, 2),
    font = _ref49[0],
    setFont = _ref49[1];
  var _ref50 = (0, _react.useState)(false),
    _ref51 = _slicedToArray(_ref50, 2),
    isProcessing = _ref51[0],
    setIsProcessing = _ref51[1]; // Track when photo is being processed (camera loader visible)
  var _ref52 = (0, _react.useState)(0),
    _ref53 = _slicedToArray(_ref52, 2),
    processingProgress = _ref53[0],
    setProcessingProgress = _ref53[1]; // Track processing progress (0-100)
  var _ref54 = (0, _react.useState)(false),
    _ref55 = _slicedToArray(_ref54, 2),
    showImage = _ref55[0],
    setShowImage = _ref55[1];
  var _ref56 = (0, _react.useState)(false),
    _ref57 = _slicedToArray(_ref56, 2),
    showEmail = _ref57[0],
    setShowEmail = _ref57[1];
  var _ref58 = (0, _react.useState)(false),
    _ref59 = _slicedToArray(_ref58, 2),
    showQRCode = _ref59[0],
    setShowQRCode = _ref59[1];
  var _ref60 = (0, _react.useState)(false),
    _ref61 = _slicedToArray(_ref60, 2),
    showPrint = _ref61[0],
    setShowPrint = _ref61[1];
  var _ref62 = (0, _react.useState)(null),
    _ref63 = _slicedToArray(_ref62, 2),
    capturedPreview = _ref63[0],
    setCapturedPreview = _ref63[1];
  // True once the reveal photo's <img> has decoded, so it can be faded in without a blank frame.
  var _ref64 = (0, _react.useState)(false),
    _ref65 = _slicedToArray(_ref64, 2),
    revealPhotoReady = _ref65[0],
    setRevealPhotoReady = _ref65[1];
  var _ref66 = (0, _react.useState)(null),
    _ref67 = _slicedToArray(_ref66, 2),
    shareImage = _ref67[0],
    setShareImage = _ref67[1];
  var emailCardRef = (0, _react.useRef)(null);
  var _ref68 = (0, _react.useState)(textDatas.print),
    _ref69 = _slicedToArray(_ref68, 2),
    printButtonText = _ref69[0],
    setPrintButtonText = _ref69[1];
  var gpios = [0, 4, 17, 22, 27];

  // Alternate ending (one toggle, two halves): after capture the photo is shown fullscreen for
  // `revealSeconds` (tap to skip), then the share screen drops the photo preview and the email card
  // and stacks retake / QR / print in a centered column. Off => the original share screen, unchanged.
  // Declared here, ABOVE the effects that close over them: `const` is not hoisted, so declaring them
  // further down (next to the other cell.* coercions) threw a ReferenceError on mount => white screen.
  var fullscreenReveal = !!cell.fullscreen_reveal;
  var revealSeconds = Math.max(1, parseInt(cell.fullscreen_reveal_duration, 10) || 3);
  // Camera-step geometry only: frame pinned to the whole cell with the live feed inside its transparent
  // window (vs the inset 2:3 box + in-box frame). The alternate layout is always fullscreen, so this is
  // implied by fullscreenReveal; `fullscreen_camera` opts the CLASSIC layout in without giving it the
  // reveal step. Deliberately separate from fullscreenReveal, which still gates the reveal step and the
  // column share layout — the classic layout goes straight from capture to its own share screen.
  var fullscreenPreview = fullscreenReveal || !!cell.fullscreen_camera;
  // Admin-configurable QR size (px). Clamped to the editor's slider range so a stale/bad value can't
  // render a 2px or screen-filling QR.
  var qrSize = Math.min(500, Math.max(60, parseInt(cell.qr_code_size, 10) || 120));
  // Multiplier on the QR card title ("Télécharger la photo"), clamped to the editor's slider range.
  var qrTitleScale = Math.min(3, Math.max(0.5, parseFloat(cell.qr_title_size) || 1));
  // Multiplier on the optional title above the print button, same range as the QR title.
  var printTitleScale = Math.min(3, Math.max(0.5, parseFloat(cell.print_title_size) || 1));
  // Multipliers on the retake / print button labels. Capped at 2 (not 3 like the titles above):
  // both buttons live in fixed-size boxes with nowrap labels and overflow beyond that.
  var retakeTextScale = Math.min(2, Math.max(0.5, parseFloat(cell.button_retake_text_size) || 1));
  var printTextScale = Math.min(2, Math.max(0.5, parseFloat(cell.print_text_size) || 1));
  // Vertical spacing (px) between the column layout's three blocks. Not `|| 32` like the consts
  // above: 0 is a valid setting (blocks touching) and would be falsy, snapping back to 32.
  var gapRaw = parseInt(cell.share_column_gap, 10);
  var shareColumnGap = Number.isFinite(gapRaw) ? Math.min(120, Math.max(0, gapRaw)) : 32;
  // Classic share screen: photo preview width (% of the cell). Width alone scales the whole preview —
  // the inner box is height:100% of an auto-height parent (portrait) or aspect-ratio 1/1 (square), so
  // the height follows the photo.
  var previewWidthRaw = parseInt(cell.share_preview_width, 10);
  var sharePreviewWidth = Number.isFinite(previewWidthRaw) ? Math.min(100, Math.max(30, previewWidthRaw)) : 73;
  // Classic share screen: percentage points added to the retake button's and the cards' `top`, moving
  // both together (e.g. down, to clear artwork in the page background). Negative moves them up.
  // Number.isFinite, not `|| 0`: 0 is the default AND a valid explicit setting.
  var controlsOffsetRaw = parseInt(cell.share_controls_offset, 10);
  var shareControlsOffset = Number.isFinite(controlsOffsetRaw) ? Math.min(60, Math.max(-20, controlsOffsetRaw)) : 0;
  // Classic share screen: percentage points added to the preview's `bottom`, lifting it off the bottom
  // edge (a shrunken preview otherwise stays glued there). Anchored on `bottom`, so a HIGHER value moves
  // it UP — hence 0..60 rather than the signed range the controls offset uses: the preview starts at the
  // bottom edge, so negative values would only push it off-screen.
  var previewOffsetRaw = parseInt(cell.share_preview_offset, 10);
  var sharePreviewOffset = Number.isFinite(previewOffsetRaw) ? Math.min(60, Math.max(0, previewOffsetRaw)) : 0;
  // Printed sheet only: where the photo sits vertically under the frame. The frame's window starts 20.5%
  // down, so a photo centred on the sheet loses its whole top band to the frame — heads clipped, empty
  // floor kept. 0 puts the photo's TOP edge on the window's top edge, so the crop comes off the bottom
  // instead; negative pulls it back up (about -20 restores the old centred framing), positive adds
  // headroom. Signed, and Number.isFinite rather than `|| 0` since 0 is both the default and a valid
  // explicit setting.
  var printPhotoOffsetRaw = parseInt(cell.print_photo_offset, 10);
  var printPhotoOffset = Number.isFinite(printPhotoOffsetRaw) ? Math.min(25, Math.max(-25, printPhotoOffsetRaw)) : 0;
  // The captured photo shown over the live feed during the capture→reveal overlap. Its <img> mounts as
  // soon as the photo exists but stays invisible until the browser has actually decoded it (onLoad),
  // so the reveal never paints an empty box.
  var revealPhotoSrc = capturedPreview || capturedImage;
  (0, _react.useEffect)(function () {
    if (step === 'share') {
      gpios.forEach(function (gpio) {
        console.log("treeosk-btn-" + gpio);
      });

      // In column mode there is no photo preview to look at while the cards stagger in, so the
      // sequential reveal would leave a near-empty screen (retake button only) for 1.5s. The
      // fullscreen reveal already did the pacing — show everything at once.
      if (fullscreenReveal) {
        setShowImage(true);
        setShowEmail(true);
        setShowQRCode(true);
        setShowPrint(true);
        return;
      }

      // reset visibility
      setShowImage(false);
      setShowEmail(false);
      setShowQRCode(false);
      setShowPrint(false);

      // Déclenchements séquentiels
      setTimeout(function () {
        return setShowImage(true);
      }, 0);
      setTimeout(function () {
        return setShowEmail(true);
      }, 500);
      setTimeout(function () {
        return setShowQRCode(true);
      }, 1000);
      setTimeout(function () {
        return setShowPrint(true);
      }, 1500);
    }
  }, [step]);

  // Auto-advance out of the fullscreen reveal. Kept as an effect rather than a setTimeout at the
  // transition site so the cleanup cancels it on unmount and on tap-to-skip (which sets step itself).
  (0, _react.useEffect)(function () {
    if (step !== 'reveal') return;
    var t = setTimeout(function () {
      return setStep('share');
    }, revealSeconds * 1000);
    return function () {
      return clearTimeout(t);
    };
  }, [step, revealSeconds]);

  // COMMENTED OUT: Flash and frozen frame states (may be needed later)
  // const [showFlash, setShowFlash] = useState(false); // Controls flash animation visibility
  // const [frozenFrame, setFrozenFrame] = useState(null); // Frozen frame image after photo capture

  // Frame overlay is fully optional: if the admin uploads no frame, no overlay is drawn.
  var gif_uri = (0, _utils.i18nData)(cell, 'gif_uri', intl, defaultLanguage);

  // Background replacement is opt-in: enabled only when the admin toggled it AND uploaded a background image.
  // When disabled, no MediaPipe model is loaded (no network), so the offline booth behaves exactly as before.
  var bgEnabled = !!(cell.remove_background && cell.background_image_uri);
  var bg_uri_transformed = bgEnabled ? uriTransformer(cell.background_image_uri) : null;

  // Photo format: 'square' produces a 15x15 (1:1) photo; anything else keeps the
  // default 10x15 (2:3) portrait. Square mode uses its own frame asset so the
  // overlay isn't stretched (falls back to the standard frame if none uploaded).
  var isSquare = cell.photo_format === 'square';
  // Admin-configurable mirror (selfie) effect. Applied as the single source of truth in
  // drawUprightFrame, so the visible preview and the captured/printed/shared file are flipped by
  // the identical code path and always match. Default off => true (un-mirrored) orientation.
  var mirror = !!cell.mirror_image;
  // Admin-configurable camera rotation (0/90/180/270°), applied ON TOP of the format's base
  // rotation (the camera is mounted sideways, so the default format already rotates +90°). Folded
  // into drawUprightFrame — the single source of truth — so the visible preview and the
  // captured/shared/printed file all rotate by the identical code path and always match. 0 => same
  // orientation as before this setting existed.
  var extraRotation = ((parseInt(cell.camera_rotation, 10) || 0) % 360 + 360) % 360;
  // Net rotation applied to the source = the format's base rotation (default 10x15 rotates +90°
  // because the camera is mounted sideways; square 15x15 does not rotate) plus the admin extra.
  // Computed once here so the crop region and drawUprightFrame share a single source of truth.
  var baseRotation = isSquare ? 0 : 90;
  var netRotation = (baseRotation + extraRotation) % 360;
  // At 90°/270° the source axes swap relative to the upright output (a sideways-mounted camera, the
  // booth default). At 0°/180° they don't (e.g. an already-upright OBS feed with camera_rotation set
  // to cancel the base 90°). The crop must extract a landscape strip when swapped, portrait when not.
  var axesSwapped = netRotation % 180 === 90;
  // Panini print (10x15 / portrait format only): print 4 copies of the same photo in a 2x2 grid on
  // one 6x4 sheet, to be cut by hand. Print-only — email/QR keep the single full photo.
  var paniniPrint = !!cell.panini_print;
  // Admin-configurable countdown. `photoTimer` is how many visible numbers show (default 3);
  // `countUp` flips the displayed digits to ascending (1,2,3) instead of descending (3,2,1).
  // LEAD_IN is the fixed "Look at the camera" arrows phase that precedes the numbers.
  var photoTimer = Math.max(1, parseInt(cell.photo_timer, 10) || 3);
  var countUp = cell.photo_timer_direction === 'asc';
  var LEAD_IN = 2; // fixed "Look at the camera" arrows intro, in seconds
  // Resolve the active frame: square frame > standard frame > none. Null means "no frame".
  var active_frame_uri = isSquare ? cell.square_gif_uri || gif_uri : gif_uri;
  var frame_overlay_uri = active_frame_uri ? uriTransformer(active_frame_uri) : null;
  var live_frame_uri = frame_overlay_uri; // live feed + share preview use the same resolved frame
  // The frame, loaded ONCE per cell for canvas use. The on-screen copies are plain <img> tags with no
  // crossOrigin; the canvas needs `crossOrigin = 'Anonymous'` or drawing it taints the canvas and
  // toDataURL throws. Browsers cache those two flavours of the same URL SEPARATELY, so the capture path
  // could never reuse the frame already on screen — it refetched from the network at shutter time behind
  // a 10s timeout, and a large animated frame that lost that race produced a saved photo with no frame
  // while the screen still showed one. Loading it at mount means it is long since ready by the shutter.
  var preloadedFrameRef = (0, _react.useRef)(null);
  // Final output canvas dimensions for the active format.
  // Square: 2160² = the native 1:1 crop from a 4K (3840×2160) feed, so there is no upscaling
  // (~366 dpi at 15 cm, exceeds the 300 dpi print target). Portrait: 1440×2160 (2:3) clears
  // 300 dpi for a 10×15 cm print (which needs ≥1181×1772).
  // The output size is FIXED: it does not follow camera_resolution. Only a 4K feed hits the crop
  // 1:1 — at 1440p/1080p the crop is smaller than the canvas and the result is upscaled (softer).
  // The capture log below ("crop:" vs "output:") is what tells you which case a booth is in.
  var OUTPUT_WIDTH = isSquare ? 2160 : 1440;
  var OUTPUT_HEIGHT = isSquare ? 2160 : 2160;

  // Segmentation tuning. Throttle inference and shrink the model input (it works at 256² internally,
  // so a small input is effectively lossless) to keep the live preview smooth on a 4K feed.
  // FEATHER_PX blurs the (low-res) mask edge once so the upscaled cutout is soft, not pixelated.
  var SEG_INTERVAL_MS = 50; // ~20 segmentations/sec
  var SEG_INPUT_MAX = 384; // longest side of the frame sent to the segmenter
  var FEATHER_PX = 2; // mask-space blur radius for a soft contour
  // The live-scene composite feeds only the preview, which downscales to ~720px. Building it at the
  // raw feed size (1920×1080) wastes ~2MP × 3 draws per segmentation on the main thread. Cap it at the
  // preview's longest side so the per-frame composite cost drops with no visible change. Capture
  // composites separately at full OUTPUT resolution (see captureFrame), so this does not affect prints.
  var SCENE_MAX = 720; // longest side of the live-preview scene canvas

  // 1. Camera constraints (16:9), per-cell via `camera_resolution` because the booth devices differ:
  //    some Android units have no 1440p/4K mode at all. `ideal` lets a lesser camera negotiate its
  //    best mode; below 4K the square crop yields fewer native pixels and the output is upscaled.
  var _ref70 = {
      '1440': [2560, 1440],
      '2160': [3840, 2160]
    }[cell.camera_resolution] || [1920, 1080],
    _ref71 = _slicedToArray(_ref70, 2),
    VIDEO_WIDTH = _ref71[0],
    VIDEO_HEIGHT = _ref71[1];

  // 2. Capture (default format): crop to 6:4 (horizontal), then rotate to portrait (4:6).
  //    Square format crops a centered square instead (see getCropRegion).
  //    The portrait crop is expressed as RATIOS of the actual frame (not fixed pixels) so the
  //    framing is identical at any camera resolution — captured from the original 1200×800 of
  //    1920×1080. Square uses min(w,h) and needs no ratio.
  var PORTRAIT_CROP_W_RATIO = 1200 / 1920; // 0.625
  var PORTRAIT_CROP_H_RATIO = 800 / 1080; // ~0.7407

  // Center-crop region of a sourceW x sourceH frame for the active format.
  // Shared by both the live preview and the capture so the framing is identical by construction.
  //
  // The crop must match how the frame is rotated downstream (see netRotation/axesSwapped):
  //  - Square: a centered square, rotation-independent.
  //  - axesSwapped (booth default, sideways camera, net 90°/270°): the legacy 3:2 LANDSCAPE crop —
  //    after the +90° rotation it becomes the upright 2:3 portrait. Ratios tuned on the booth; kept
  //    byte-identical so physical booths are unaffected.
  //  - not swapped (e.g. an already-upright OBS feed with camera_rotation cancelling the base 90°,
  //    net 0°/180°): crop a centered region whose aspect already matches the 2:3 portrait output,
  //    so it fills the canvas with no warp and no extreme zoom.
  var getCropRegion = function getCropRegion(sourceW, sourceH) {
    var cropW, cropH;
    if (isSquare) {
      cropW = cropH = Math.min(sourceW, sourceH);
    } else if (axesSwapped) {
      cropW = Math.round(sourceW * PORTRAIT_CROP_W_RATIO);
      cropH = Math.round(sourceH * PORTRAIT_CROP_H_RATIO);
    } else {
      // Largest centered region of the source with the output's portrait aspect (OUTPUT_WIDTH:OUTPUT_HEIGHT).
      var targetAspect = OUTPUT_WIDTH / OUTPUT_HEIGHT; // < 1 (portrait)
      if (sourceW / sourceH > targetAspect) {
        // Source is wider than target: height-limited (e.g. 1920x1080 -> 720x1080).
        cropH = sourceH;
        cropW = Math.round(sourceH * targetAspect);
      } else {
        cropW = sourceW;
        cropH = Math.round(sourceW / targetAspect);
      }
    }
    var sWidth = Math.min(cropW, sourceW);
    var sHeight = Math.min(cropH, sourceH);
    var sx = Math.max(0, Math.floor((sourceW - sWidth) / 2));
    var sy = Math.max(0, Math.floor((sourceH - sHeight) / 2));
    return {
      sx: sx,
      sy: sy,
      sWidth: sWidth,
      sHeight: sHeight
    };
  };

  // Draw the cropped region cover-fit into a canvasW x canvasH canvas, optionally rotated +90°.
  // The default (portrait) format rotates because the camera is mounted sideways; the square
  // (15x15) format does NOT rotate (rotate90 = false). Factored out so the live preview and the
  // capture produce the same image (minus the frame overlay, which is drawn on top afterwards).
  var drawUprightFrame = function drawUprightFrame(ctx, canvasW, canvasH, source, sx, sy, sWidth, sHeight) {
    var rotate90 = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : true;
    var mirror = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : false;
    ctx.clearRect(0, 0, canvasW, canvasH);
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvasW, canvasH);
    ctx.save();
    ctx.translate(canvasW / 2, canvasH / 2);
    // Horizontal flip BEFORE the rotate: scale-then-rotate yields a clean horizontal mirror of the
    // final upright image. (Doing it after the rotate would flip vertically instead.) Contained in
    // this save/restore so the frame/GIF overlay drawn afterwards is never mirrored.
    if (mirror) ctx.scale(-1, 1);
    // Rotation + axis-swap come from component scope (netRotation/axesSwapped) so the crop region and
    // this draw stay in lockstep — the format's base rotation plus the admin extra. The `rotate90`
    // param is vestigial (always !isSquare, which netRotation already encodes); kept for signature
    // stability at the existing callsites.
    if (netRotation) ctx.rotate(netRotation * Math.PI / 180);
    // At 90°/270° (axesSwapped) the canvas axes swap relative to the source, so the cover-fit math
    // must compare against the inverted aspect and swap which canvas dimension each draw extent maps to.
    var videoAspect = sWidth / sHeight;
    var canvasAspect = axesSwapped ? canvasH / canvasW : canvasW / canvasH;
    var drawW, drawH;
    if (videoAspect > canvasAspect) {
      drawH = axesSwapped ? canvasW : canvasH;
      drawW = drawH * videoAspect;
    } else {
      drawW = axesSwapped ? canvasH : canvasW;
      drawH = drawW / videoAspect;
    }
    ctx.drawImage(source, sx, sy, sWidth, sHeight, -drawW / 2, -drawH / 2, drawW, drawH);
    ctx.restore();
  };
  (0, _react.useEffect)(function () {
    preloadedFrameRef.current = null;
    if (!frame_overlay_uri) return;
    var img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = function () {
      preloadedFrameRef.current = img;
      console.log('[photobooth] frame preloaded for canvas use:', img.naturalWidth + 'x' + img.naturalHeight);
    };
    // A failure here means the saved photo will have NO frame even though the screen shows one, so say
    // exactly that: the usual cause is the asset host not sending Access-Control-Allow-Origin, which
    // only affects the crossOrigin load the canvas needs — a server-side fix, not a client one.
    img.onerror = function () {
      return console.error('[photobooth] frame could NOT be loaded for the canvas (missing CORS header on the asset host?).' + ' Printed and emailed photos will have no frame:', frame_overlay_uri);
    };
    img.src = frame_overlay_uri;
  }, [frame_overlay_uri]);
  var handleVisibilityChange = function handleVisibilityChange() {
    if (document.visibilityState === 'visible' && (step === 'camera' || step === 'countdown')) {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(function (track) {
          return track.stop();
        });
        streamRef.current = null;
      }
      if (videoRef.current) {
        videoRef.current.srcObject = null;
      }
      setTimeout(function () {
        _initializeCamera();
      }, 300);
    }
  };
  (0, _react.useEffect)(function () {
    if (step === 'camera') {
      _initializeCamera();
      document.addEventListener('visibilitychange', handleVisibilityChange);
    }
    return function () {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      if (step !== 'camera' && step !== 'countdown') {
        if (animationFrameId.current) {
          cancelAnimationFrame(animationFrameId.current);
          animationFrameId.current = null;
        }
        if (streamRef.current) {
          streamRef.current.getTracks().forEach(function (track) {
            track.stop();
          });
          streamRef.current = null;
        }
        if (videoRef.current) {
          videoRef.current.srcObject = null;
        }
        setHasCamera(false);
      }
    };
  }, [step]);

  // Pause video feed when processing (UI only - doesn't affect backend)
  (0, _react.useEffect)(function () {
    if (isProcessing && videoRef.current) {
      videoRef.current.pause();
    } else if (!isProcessing && videoRef.current && hasCamera && step === 'camera') {
      // Resume video if we're back to camera step and not processing
      videoRef.current.play().catch(function (e) {
        console.warn('Could not resume video:', e);
      });
    }
  }, [isProcessing, hasCamera, step]);

  // Automatically generate QR code when step becomes 'share' and image is captured
  (0, _react.useEffect)(function () {
    // 'reveal' starts the upload too, so the seconds spent showing the photo fullscreen overlap the
    // upload instead of the user landing on the share screen and waiting on the QR spinner.
    if ((step === 'share' || step === 'reveal') && capturedImage && !link && !isSending && cell.qr_code) {
      // Automatically trigger share to generate QR code/link
      handleShare();
    }
  }, [step, capturedImage, link, isSending, cell.qr_code]);

  // Text font for ALL cell text. A cell-level choice (cell.text_font, a font NAME uploaded in the
  // project settings and injected globally as @font-face) wins; otherwise fall back to the project
  // default button font. This single value flows to the root BackgroundWrapper (whose family every
  // styled component now inherits), UserInfoOverlay, the inline info spans, and drawUserInfo's canvas.
  (0, _react.useEffect)(function () {
    setFont(cell.text_font || project && project.default_button_font || '');
  }, [cell.text_font, project]);

  // Preload the admin-uploaded background image so it is ready at capture time.
  (0, _react.useEffect)(function () {
    if (!bgEnabled) {
      backgroundImageRef.current = null;
      return;
    }
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = bg_uri_transformed;
    backgroundImageRef.current = img;
  }, [bgEnabled, bg_uri_transformed]);

  // Initialize MediaPipe Selfie Segmentation only when background replacement is enabled.
  // The npm import is bundled at build time and makes no network request; the CDN fetch
  // (model + WASM) happens here, on initialize(), so an offline/feature-off booth is untouched.
  (0, _react.useEffect)(function () {
    if (!bgEnabled) return;
    var seg = new _selfie_segmentation.SelfieSegmentation({
      locateFile: function locateFile(file) {
        return "https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/".concat(file);
      }
    });
    seg.setOptions({
      modelSelection: 0,
      // 0 = general model, more accurate for an upright portrait subject
      selfieMode: false
    });
    // The booth camera is mounted sideways (the capture rotates +90° to make the photo upright),
    // so the raw frame shows the person lying horizontally — which the model segments poorly.
    // We feed the segmenter an UPRIGHT frame, then rotate its mask back into raw-frame space so the
    // rest of the pipeline (capture compositing) keeps working in raw coordinates unchanged.
    seg.onResults(function (results) {
      var video = videoRef.current;
      if (!results.segmentationMask || !video) return;
      var vw = video.videoWidth;
      var vh = video.videoHeight;
      if (!vw || !vh) return;

      // Rotate the (small) upright mask back -90° into raw-frame orientation. Kept at the mask's own
      // low resolution — consumers upscale it on draw — and feathered once here with a blur so the
      // upscaled cutout edge is soft instead of pixelated (inherited by live preview + capture).
      var mw = results.segmentationMask.width;
      var mh = results.segmentationMask.height;
      var rawMask = rawMaskCanvasRef.current;
      if (!rawMask) {
        rawMask = document.createElement('canvas');
        rawMaskCanvasRef.current = rawMask;
      }
      if (rawMask.width !== mh) rawMask.width = mh; // rotated: swap dims
      if (rawMask.height !== mw) rawMask.height = mw;
      var mctx = rawMask.getContext('2d');
      mctx.save();
      mctx.imageSmoothingEnabled = true;
      mctx.imageSmoothingQuality = 'high';
      mctx.clearRect(0, 0, rawMask.width, rawMask.height);
      mctx.translate(rawMask.width / 2, rawMask.height / 2);
      mctx.rotate(-Math.PI / 2);
      mctx.filter = "blur(".concat(FEATHER_PX, "px)");
      mctx.drawImage(results.segmentationMask, -mw / 2, -mh / 2, mw, mh);
      mctx.filter = 'none';
      mctx.restore();
      segmentationMaskRef.current = rawMask;

      // Live preview scene: composite cut-out person over the background, in raw-frame space.
      // Drawn into an offscreen buffer; the visible-preview loop crops/rotates it to match capture.
      var scene = liveSceneRef.current;
      if (!scene) {
        scene = document.createElement('canvas');
        liveSceneRef.current = scene;
      }
      var canvas = scene;
      var bg = backgroundImageRef.current;
      if (canvas && bg && bg.complete && bg.naturalWidth) {
        // Scene is a preview-resolution proxy of the raw feed: same aspect (vw:vh) so the preview's
        // crop math applies unchanged, but capped at SCENE_MAX so the composite is cheap.
        var sceneScale = Math.min(1, SCENE_MAX / Math.max(vw, vh));
        var sw = Math.max(1, Math.round(vw * sceneScale));
        var sh = Math.max(1, Math.round(vh * sceneScale));
        if (canvas.width !== sw) canvas.width = sw;
        if (canvas.height !== sh) canvas.height = sh;
        var ctx = canvas.getContext('2d');
        ctx.save();
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.clearRect(0, 0, sw, sh);
        ctx.globalCompositeOperation = 'source-over';
        ctx.drawImage(video, 0, 0, sw, sh);
        ctx.globalCompositeOperation = 'destination-in';
        ctx.drawImage(rawMask, 0, 0, sw, sh); // small feathered mask upscaled with smoothing
        ctx.globalCompositeOperation = 'destination-over';
        var bgRatio = bg.naturalWidth / bg.naturalHeight;
        var cRatio = sw / sh;
        var dw, dh, dx, dy;
        if (bgRatio > cRatio) {
          dh = sh;
          dw = sh * bgRatio;
          dx = (sw - dw) / 2;
          dy = 0;
        } else {
          dw = sw;
          dh = sw / bgRatio;
          dx = 0;
          dy = (sh - dh) / 2;
        }
        ctx.drawImage(bg, dx, dy, dw, dh);
        ctx.restore();
      }
    });
    // If the CDN is unreachable, log and leave the mask null -> capture falls back to raw video.
    seg.initialize().catch(function (err) {
      console.error('SelfieSegmentation init failed, falling back to raw capture:', err);
    });
    selfieSegmentationRef.current = seg;
    return function () {
      try {
        seg.close();
      } catch (e) {/* noop */}
      selfieSegmentationRef.current = null;
      segmentationMaskRef.current = null;
    };
  }, [bgEnabled]);

  // Feed live frames to the segmenter while the camera is showing, so a fresh mask is ready at capture.
  (0, _react.useEffect)(function () {
    if (!bgEnabled) return;
    if (!hasCamera) return;
    if (step !== 'camera' && step !== 'countdown') return;
    var active = true;
    var lastSent = 0;
    var lastInfLog = 0; // throttles the per-inference timing log (Step 0 diagnostic)
    var _loop = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var video, now, vw, vh, scale, dw, dh, upright, uctx, t0, infMs, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (active) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              video = videoRef.current;
              now = performance.now(); // Throttle to ~SEG_INTERVAL_MS: model inference is the dominant cost; the visible preview loop
              // still runs every frame from the latest scene, so motion stays smooth.
              if (!(video && video.readyState >= 2 && selfieSegmentationRef.current && now - lastSent >= SEG_INTERVAL_MS)) {
                _context.n = 5;
                break;
              }
              lastSent = now;
              _context.p = 2;
              vw = video.videoWidth;
              vh = video.videoHeight; // Downscale + rotate the raw frame into a SMALL upright input (person stands vertically).
              // Sending ~384px instead of the full 4K frame is ~100× fewer pixels with no accuracy loss.
              scale = SEG_INPUT_MAX / Math.max(vw, vh);
              dw = Math.max(1, Math.round(vw * scale));
              dh = Math.max(1, Math.round(vh * scale));
              upright = uprightInputRef.current;
              if (!upright) {
                upright = document.createElement('canvas');
                uprightInputRef.current = upright;
              }
              if (upright.width !== dh) upright.width = dh; // rotated dims: width <- scaled height
              if (upright.height !== dw) upright.height = dw; // height <- scaled width
              uctx = upright.getContext('2d');
              uctx.save();
              uctx.imageSmoothingEnabled = true;
              uctx.imageSmoothingQuality = 'high';
              uctx.clearRect(0, 0, upright.width, upright.height);
              uctx.translate(upright.width / 2, upright.height / 2);
              uctx.rotate(Math.PI / 2);
              uctx.drawImage(video, -dw / 2, -dh / 2, dw, dh);
              uctx.restore();
              // Diagnostic (Step 0): per-inference wall time on the target device. This is the number
              // that decides whether a GPU delegate / Worker is warranted. Logged every ~2s to avoid spam.
              t0 = performance.now();
              _context.n = 3;
              return selfieSegmentationRef.current.send({
                image: upright
              });
            case 3:
              infMs = performance.now() - t0;
              if (now - lastInfLog >= 2000) {
                lastInfLog = now;
                console.log('[photobooth] segmentation inference ms:', infMs.toFixed(1));
              }
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t2 = _context.v;
            case 5:
              if (active) segLoopRef.current = requestAnimationFrame(_loop);
            case 6:
              return _context.a(2);
          }
        }, _callee, null, [[2, 4]]);
      }));
      return function loop() {
        return _ref.apply(this, arguments);
      };
    }();
    _loop();
    return function () {
      active = false;
      if (segLoopRef.current) {
        cancelAnimationFrame(segLoopRef.current);
        segLoopRef.current = null;
      }
    };
  }, [bgEnabled, hasCamera, step]);

  // Visible preview loop: draw the live feed into displayCanvasRef using the SAME center-crop +
  // rotate as the capture, so what the user sees matches the final image by construction (no more
  // eyeballed CSS scale factors). When background replacement is active and a composited scene is
  // ready, that scene is the source; otherwise the raw video. The canvas is already upright, so it
  // is displayed with no CSS rotation — only the existing mirror (preserved as-is).
  (0, _react.useEffect)(function () {
    if (step !== 'camera' && step !== 'countdown') return;
    if (!hasCamera) return;

    // Cap the preview's internal resolution so the per-frame draw stays cheap regardless of the
    // (now 4K) output size. Aspect ratio — and therefore framing — is preserved exactly.
    var PREVIEW_MAX = 720;
    var previewScale = PREVIEW_MAX / Math.max(OUTPUT_WIDTH, OUTPUT_HEIGHT);
    var cw = Math.round(OUTPUT_WIDTH * previewScale);
    var ch = Math.round(OUTPUT_HEIGHT * previewScale);
    var active = true;
    var _loop2 = function loop() {
      if (!active) return;
      var video = videoRef.current;
      var display = displayCanvasRef.current;
      if (video && display && video.readyState >= 2 && video.videoWidth && video.videoHeight) {
        var vw = video.videoWidth;
        var vh = video.videoHeight;
        if (display.width !== cw) display.width = cw;
        if (display.height !== ch) display.height = ch;
        var ctx = display.getContext('2d');
        // Scene is a preview-res proxy with the SAME aspect as the video (both derive from vw:vh), so
        // its crop region is the video's crop scaled by the same factor — compute it from the source's
        // own dimensions instead of assuming the source matches the raw feed size.
        var scene = liveSceneRef.current;
        var sceneAspectOk = scene && Math.abs(scene.width / scene.height - vw / vh) < 0.01;
        var source = bgEnabled && sceneAspectOk ? scene : video;
        var _getCropRegion = getCropRegion(source.width || vw, source.height || vh),
          sx = _getCropRegion.sx,
          sy = _getCropRegion.sy,
          sWidth = _getCropRegion.sWidth,
          sHeight = _getCropRegion.sHeight;
        drawUprightFrame(ctx, cw, ch, source, sx, sy, sWidth, sHeight, !isSquare, mirror);
      }
      previewLoopRef.current = requestAnimationFrame(_loop2);
    };
    _loop2();
    return function () {
      active = false;
      if (previewLoopRef.current) {
        cancelAnimationFrame(previewLoopRef.current);
        previewLoopRef.current = null;
      }
    };
  }, [step, hasCamera, bgEnabled, isSquare, mirror, extraRotation]);

  // Helper: Find camera deviceId by label substring
  function getCameraDeviceIdByLabel(_x) {
    return _getCameraDeviceIdByLabel.apply(this, arguments);
  } // Update initializeCamera to use the helper
  function _getCameraDeviceIdByLabel() {
    _getCameraDeviceIdByLabel = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(labelSubstring) {
      var devices, cameras, match;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return navigator.mediaDevices.enumerateDevices();
          case 1:
            devices = _context2.v;
            // Only available after user has granted camera access at least once
            cameras = devices.filter(function (d) {
              return d.kind === 'videoinput';
            }); // Try to find a camera whose label includes the substring (case-insensitive)
            match = cameras.find(function (cam) {
              return cam.label && cam.label.toLowerCase().includes(labelSubstring.toLowerCase());
            });
            return _context2.a(2, match ? match.deviceId : cameras[0] ? cameras[0].deviceId : null);
        }
      }, _callee2);
    }));
    return _getCameraDeviceIdByLabel.apply(this, arguments);
  }
  var _initializeCamera = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var labelSubstring, deviceId, constraints, stream, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            if (animationFrameId.current) {
              cancelAnimationFrame(animationFrameId.current);
              animationFrameId.current = null;
            }
            if (streamRef.current) {
              streamRef.current.getTracks().forEach(function (track) {
                return track.stop();
              });
              streamRef.current = null;
            }
            if (videoRef.current) {
              videoRef.current.srcObject = null;
            }
            _context3.p = 1;
            // Choose the relevant camera by label substring (e.g., "logitech" or your camera's name)
            labelSubstring = cell.cameralabel; // <-- Change this to match your camera label
            console.log({
              cell: cell
            });
            _context3.n = 2;
            return getCameraDeviceIdByLabel(labelSubstring);
          case 2:
            deviceId = _context3.v;
            constraints = {
              video: {
                // `max` as well as `ideal`: `ideal` is only a hint and this camera ignores it, defaulting
                // to its top 2560x1440 mode. `max` is a hard cap the camera cannot exceed.
                width: {
                  ideal: VIDEO_WIDTH,
                  max: VIDEO_WIDTH
                },
                height: {
                  ideal: VIDEO_HEIGHT,
                  max: VIDEO_HEIGHT
                },
                // Request a smooth framerate explicitly: without this, a camera often picks its highest
                // RESOLUTION mode, which on many webcams runs at 15fps (or less) — the usual cause of a
                // "slow" live feed. `ideal:30, min:24` steers it to a 24–30fps mode.
                // But `min` is REQUIRED (only `ideal` is a hint), so above 1080p it would silently cancel the
                // resolution the admin picked: a device whose 4K mode runs at 15fps cannot satisfy both, so
                // getUserMedia hands back 1080p and *succeeds*. Keep the floor only at 1080p, where 24fps+ is
                // universal; above it, resolution is the setting’s whole point and fps gives way.
                // ponytail: no per-device fps table — the admin drops to 1440p if 4K is visibly choppy.
                frameRate: VIDEO_HEIGHT > 1080 ? {
                  ideal: 30
                } : {
                  ideal: 30,
                  min: 24
                },
                facingMode: 'user',
                deviceId: deviceId ? {
                  exact: deviceId
                } : undefined
              },
              audio: false
            };
            _context3.n = 3;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 300);
            });
          case 3:
            _context3.n = 4;
            return navigator.mediaDevices.getUserMedia(constraints);
          case 4:
            stream = _context3.v;
            if (videoRef.current) {
              videoRef.current.srcObject = stream;
              videoRef.current.onloadedmetadata = function () {
                // Diagnostic: the resolution AND framerate actually negotiated. If the feed looks slow,
                // check fps here first — a low fps (e.g. 15) means the camera chose a high-res/low-fps mode
                // and is the feed's true bottleneck, independent of any canvas/draw cost.
                var track = stream.getVideoTracks()[0];
                var settings = track ? track.getSettings() : {};
                console.log('[photobooth] camera negotiated:', videoRef.current.videoWidth + 'x' + videoRef.current.videoHeight, '@', settings.frameRate != null ? Math.round(settings.frameRate) + 'fps' : 'fps unknown');
                videoRef.current.play().then(function () {
                  setHasCamera(true);
                  setCameraError(null);
                }).catch(function (e) {
                  setCameraError(e.message);
                });
              };
              streamRef.current = stream;
            }
            _context3.n = 6;
            break;
          case 5:
            _context3.p = 5;
            _t3 = _context3.v;
            setCameraError(_t3.message);
            setHasCamera(false);
            if (step === 'camera' || step === 'countdown') {
              setTimeout(function () {
                _initializeCamera();
              }, 1000);
            }
          case 6:
            return _context3.a(2);
        }
      }, _callee3, null, [[1, 5]]);
    }));
    return function initializeCamera() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleTakePhoto = function handleTakePhoto() {
    if (step === 'camera' && hasCamera) {
      // Clear any previous shot so the reveal overlay can't show a stale photo over the countdown.
      setCapturedPreview(null);
      setRevealPhotoReady(false);
      setStep('countdown');
      startCountdown();
    }
  };

  // COMMENTED OUT: Frozen frame capture function (may be needed later)
  // Capture frozen frame from video to show while processing
  // const captureFrozenFrame = () => {
  //   if (!videoRef.current) return null;
  //
  //   const video = videoRef.current;
  //   // Check if video is ready
  //   if (video.videoWidth === 0 || video.videoHeight === 0) {
  //     return null;
  //   }

  //   const canvas = document.createElement('canvas');
  //   // Rotate 90°: swap width and height
  //   canvas.width = video.videoHeight;
  //   canvas.height = video.videoWidth;
  //   const ctx = canvas.getContext('2d');
  //
  //   // Rotate 90° clockwise and apply mirror effect to match video display
  //   ctx.translate(canvas.width, 0);
  //   ctx.rotate(Math.PI / 2); // 90° clockwise
  //   ctx.scale(-1, 1); // Mirror effect
  //   ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
  //
  //   return canvas.toDataURL('image/jpeg', 0.9);
  // };

  var startCountdown = function startCountdown() {
    setCountdown(photoTimer + LEAD_IN);
    var countdownInterval = setInterval(function () {
      setCountdown(function (prev) {
        if (prev <= 0) {
          clearInterval(countdownInterval);
          // When countdown reaches 0, show camera loader and pause video feed (UI only)
          setIsProcessing(true);
          setProcessingProgress(0); // Reset progress
          // Pause video feed immediately when processing starts (UI only - doesn't affect backend)
          if (videoRef.current) {
            videoRef.current.pause();
          }

          // Start progress animation - increments from 0% to 90% gradually
          // Progress will jump to 100% when actual photo processing completes
          var progress = 0;
          progressIntervalRef.current = setInterval(function () {
            progress += 2; // Increment by 2% every ~200ms
            if (progress >= 90) {
              progress = 90; // Cap at 90% until actual processing completes
            }
            setProcessingProgress(progress);
          }, 200);

          // Capture photo (runs in background while video is paused in UI)
          capturePhoto();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  // Build a 2x2 tiled (panini) version of a captured photo data URL. The source already has the
  // frame baked in, so each of the 4 quadrants is a full framed copy. A 2x2 grid of a 2:3 image is
  // itself 2:3, so the result flows through the existing portrait print path unchanged.
  var buildPaniniImage = function buildPaniniImage(imageDataUrl) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        var tileW = img.naturalWidth || OUTPUT_WIDTH;
        var tileH = img.naturalHeight || OUTPUT_HEIGHT;
        var canvas = document.createElement('canvas');
        canvas.width = tileW * 2;
        canvas.height = tileH * 2;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, tileW, tileH);
        ctx.drawImage(img, tileW, 0, tileW, tileH);
        ctx.drawImage(img, 0, tileH, tileW, tileH);
        ctx.drawImage(img, tileW, tileH, tileW, tileH);
        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = reject;
      img.src = imageDataUrl;
    });
  };
  function printImageData(imageDataUrl) {
    var isPanini = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (printed) return;
    console.log('treeosk-print'); // diffuser marker: fires once per print tap (see rpi-service watcher)
    if (window.electronAPI) {
      // Pass the format so the Electron side selects the page layout:
      //  - square: 150×150mm page
      //  - panini: exact 152×102mm (6×4) page with NO calibration fudge, so the 2x2 cut seam lands
      //    on the true paper center (the default portrait path is centered on the printable area,
      //    which is offset from the physical paper center — invisible for one photo, not for a cut).
      //  - default: the existing calibrated portrait (A4 + fudge) layout.
      window.electronAPI.sendImageForPrint(imageDataUrl, {
        square: isSquare,
        panini: isPanini
      });
    }
    if (window.Android && typeof window.Android.postMessage === 'function') {
      window.Android.postMessage(imageDataUrl);
    }
    setPrinted(true);
  }
  var fallbackCapturePhoto = function fallbackCapturePhoto() {
    if (!videoRef.current || !previewCanvasRef.current) {
      console.error('❌ Video or canvas not available');
      return;
    }
    var canvas = previewCanvasRef.current;
    var context = canvas.getContext('2d');
    var video = videoRef.current;

    // Check if video is ready
    if (video.videoWidth === 0 || video.videoHeight === 0) {
      console.error('❌ Video not ready');
      // COMMENTED OUT: Frozen frame state reset (may be needed later)
      // setIsProcessing(false);
      // setFrozenFrame(null);
      return;
    }
    // 1. Crop the source region from the 16:9 video.
    //    - default: center 6:4 region, then rotated to a 2:3 portrait
    //    - square : center square region (no distortion once cover-fit into the 1:1 canvas)
    // Shared with the live preview (getCropRegion) so framing matches exactly.
    var _getCropRegion2 = getCropRegion(video.videoWidth, video.videoHeight),
      sx = _getCropRegion2.sx,
      sy = _getCropRegion2.sy,
      sWidth = _getCropRegion2.sWidth,
      sHeight = _getCropRegion2.sHeight;
    var targetWidth = sWidth;
    var targetHeight = sHeight;

    // 2. Prepare canvas for the active output format (overwritten in processPhotoCapture).
    canvas.width = OUTPUT_WIDTH;
    canvas.height = OUTPUT_HEIGHT;

    // No frame uploaded -> capture the photo without any overlay.
    if (!frame_overlay_uri) {
      processPhotoCapture(context, canvas, video, sx, sy, sWidth, sHeight, null);
      return;
    }

    // Preloaded at mount (see preloadedFrameRef): use it and skip the fetch-and-race entirely. The
    // on-demand path below stays as the fallback for the window where the preload has not finished.
    var preloaded = preloadedFrameRef.current;
    if (preloaded && preloaded.naturalWidth && preloaded.naturalHeight) {
      processPhotoCapture(context, canvas, video, sx, sy, sWidth, sHeight, preloaded);
      return;
    }
    var gifImg = new Image(targetWidth, targetHeight);
    gifImg.style.backgroundColor = 'white';
    gifImg.style.width = '100%';
    gifImg.style.height = '100%';
    gifImg.style.objectFit = 'cover';
    gifImg.style.objectPosition = 'center';
    gifImg.height = targetHeight;
    gifImg.width = targetWidth;
    gifImg.style.backgroundSize = 'cover';
    gifImg.crossOrigin = 'Anonymous';

    // Add timeout to prevent infinite waiting
    var timeoutId = setTimeout(function () {
      console.warn('⚠️ GIF image load timeout — the saved photo will have NO frame even though the screen' + ' shows one. The mount-time preload should normally have won this race:', frame_overlay_uri);
      // Proceed with photo capture even if GIF fails to load.
      // NB: must pass the full crop region (sx, sy, sWidth, sHeight) like the onload/onerror paths —
      // this call previously passed (targetWidth, targetHeight, null), i.e. 5 args into an 8-arg
      // signature, so sWidth/sHeight arrived undefined and the capture drew from a broken crop.
      processPhotoCapture(context, canvas, video, sx, sy, sWidth, sHeight, null);
    }, 10000); // 10 second timeout

    gifImg.onload = function () {
      clearTimeout(timeoutId);
      console.log(gifImg);
      processPhotoCapture(context, canvas, video, sx, sy, sWidth, sHeight, gifImg);
    };
    gifImg.onerror = function (error) {
      clearTimeout(timeoutId);
      console.error('❌ Error loading GIF overlay:', error);
      // Proceed with photo capture even if GIF fails to load
      processPhotoCapture(context, canvas, video, sx, sy, sWidth, sHeight, null);
    };
    gifImg.src = frame_overlay_uri;
  };

  // Build a "scene" canvas (same dimensions as the raw video frame) where the segmented
  // person is composited over the uploaded background image. Because it shares the video's
  // dimensions, the existing crop (sx/sy/sWidth/sHeight) + rotation pipeline applies unchanged.
  // Returns null when background replacement can't run -> caller falls back to the raw video.
  var buildSceneCanvas = function buildSceneCanvas(video) {
    if (!bgEnabled) return null;
    if (!segmentationMaskRef.current) return null; // mask not ready yet
    var bg = backgroundImageRef.current;
    if (!bg || !bg.complete || !bg.naturalWidth) return null; // background not loaded yet

    var w = video.videoWidth;
    var h = video.videoHeight;
    if (!w || !h) return null;

    // 1. Cut the person out of the raw frame using the segmentation mask (transparent elsewhere).
    var person = document.createElement('canvas');
    person.width = w;
    person.height = h;
    var pctx = person.getContext('2d');
    pctx.imageSmoothingEnabled = true;
    pctx.imageSmoothingQuality = 'high';
    pctx.drawImage(video, 0, 0, w, h);
    pctx.globalCompositeOperation = 'destination-in';
    pctx.drawImage(segmentationMaskRef.current, 0, 0, w, h);
    pctx.globalCompositeOperation = 'source-over';

    // 2. Compose background (cover-fit) then the person on top.
    var scene = document.createElement('canvas');
    scene.width = w;
    scene.height = h;
    var sctx = scene.getContext('2d');
    sctx.imageSmoothingEnabled = true;
    sctx.imageSmoothingQuality = 'high';
    var bgRatio = bg.naturalWidth / bg.naturalHeight;
    var canvasRatio = w / h;
    var dw, dh, dx, dy;
    if (bgRatio > canvasRatio) {
      dh = h;
      dw = h * bgRatio;
      dx = (w - dw) / 2;
      dy = 0;
    } else {
      dw = w;
      dh = w / bgRatio;
      dx = 0;
      dy = (h - dh) / 2;
    }
    sctx.drawImage(bg, dx, dy, dw, dh);
    sctx.drawImage(person, 0, 0, w, h);
    return scene;
  };

  // Draw the user-info bar (first name / surname + birthdate) onto a canvas, like the Panini card.
  // Called on the preview, share AND print canvases so on-screen, QR/email, and print all match.
  var drawUserInfo = function drawUserInfo(ctx, w, h) {
    if (!cell.collect_user_info) return;
    if (!userFirstName && !userSurname && !userBirthdate) return;
    // Admin-configurable: text size (scale multiplier) and vertical position (% from the bottom).
    var sizeScale = cell.user_info_text_size || 1;
    var posPct = (cell.user_info_text_position != null ? cell.user_info_text_position : 12) / 100;
    var hPosPct = (cell.user_info_text_h_position != null ? cell.user_info_text_h_position : 50) / 100;
    var nameSize = Math.round(h * 0.042 * sizeScale); // ≈ previous barH*0.3 at scale 1
    var dateSize = Math.round(h * 0.031 * sizeScale); // ≈ previous barH*0.22 at scale 1
    // Anchor the name line at `position` % above the bottom; the date sits just under it.
    var nameY = h - h * posPct;
    var centerX = w * hPosPct; // horizontal center: 0 = left, 0.5 = center, 1 = right
    var dateY = nameY + nameSize * 0.95;
    ctx.save();
    // No background bar — text is drawn directly over the photo. No shadow.
    ctx.fillStyle = cell.user_info_text_color || '#fff';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    var family = font || 'Arial';
    // Line 1: first name (regular) + surname (bold), centered together.
    var first = (userFirstName || '').trim();
    var last = (userSurname || '').trim().toUpperCase();
    var gap = first && last ? nameSize * 0.3 : 0;
    ctx.font = "".concat(nameSize, "px ").concat(family);
    var firstW = first ? ctx.measureText(first).width : 0;
    ctx.font = "900 ".concat(nameSize, "px ").concat(family);
    var lastW = last ? ctx.measureText(last).width : 0;
    var totalW = firstW + gap + lastW;
    var cursor = centerX - totalW / 2;
    ctx.textAlign = 'left';
    if (first) {
      ctx.font = "".concat(nameSize, "px ").concat(family);
      ctx.fillText(first, cursor, nameY);
      cursor += firstW + gap;
    }
    if (last) {
      ctx.font = "900 ".concat(nameSize, "px ").concat(family);
      ctx.fillText(last, cursor, nameY);
    }
    // Line 2: birthdate, centered, just under the name.
    if (userBirthdate) {
      ctx.textAlign = 'center';
      ctx.font = "".concat(dateSize, "px ").concat(family);
      ctx.fillText(userBirthdate.trim(), centerX, dateY);
    }
    ctx.restore();
  };

  // Helper function to process photo capture
  var processPhotoCapture = function processPhotoCapture(context, canvas, video, sx, sy, sWidth, sHeight, gifImg) {
    try {
      // When background replacement is active and ready, draw from the composited scene instead
      // of the raw video. The scene shares the video's dimensions, so all crop/rotation math below
      // stays identical and applies to every output (preview, share, print).
      var frameSource = buildSceneCanvas(video) || video;
      canvas.width = OUTPUT_WIDTH;
      canvas.height = OUTPUT_HEIGHT;

      // Diagnostic: what the camera actually delivered vs what we crop/output. If the short axis is
      // below the output size, the result is upscaled (softer) — check this if quality looks low.
      console.log('[photobooth] capture res — video:', video.videoWidth + 'x' + video.videoHeight, '| crop:', sWidth + 'x' + sHeight, '| output:', OUTPUT_WIDTH + 'x' + OUTPUT_HEIGHT);
      // Did the frame overlay actually reach the canvas? If this logs false/undefined the saved image has
      // no frame at all (load failed/timed out); if it logs true the frame is present and any complaint
      // about "no filter" is a composition/geometry problem, not a missing asset.
      console.log('[photobooth] frame overlay:', !!gifImg, gifImg ? gifImg.naturalWidth + 'x' + gifImg.naturalHeight : '(none)');

      // TWO deliberate compositions, because the screen and the paper are different shapes:
      //
      //  - emailed / QR file: the frame at its NATIVE 9:16 size with the photo in its transparent window,
      //    i.e. exactly what the live preview shows. Nothing cropped, nothing stretched. The window is
      //    itself 2:3 (0.669 vs the photo's 0.667), so the photo goes in undistorted.
      //  - printed sheet (below): the photo full-bleed and undistorted at 2:3 with the whole frame
      //    stretched over it. The frame's window then reveals ~88% x 74% of the photo, so the print is a
      //    slightly tighter crop of what the user framed — the accepted, explained trade.
      //
      // Needs the frame's real pixels, hence the naturalWidth/Height guard. Gated on fullscreenPreview:
      // a frame authored for 2:3 or 1:1 output has no full-screen window and keeps the print composition.
      var frameShare = fullscreenPreview && gifImg && gifImg.naturalWidth && gifImg.naturalHeight;

      // Paint the windowed composition into a w x h target sized to the frame.
      var drawWindowedShare = function drawWindowedShare(ctx, w, h) {
        var _windowRect = windowRect(w, h),
          wx = _windowRect.wx,
          wy = _windowRect.wy,
          ww = _windowRect.ww,
          wh = _windowRect.wh;
        // Background behind the window, so any transparent frame pixel outside the photo is not left black.
        ctx.fillStyle = cell.background_color && !/rgba\(\s*0\s*,\s*0\s*,\s*0\s*,\s*0\s*\)/.test(cell.background_color) ? cell.background_color : '#FFFFFF';
        ctx.fillRect(0, 0, w, h);
        // The offscreen canvas is sized to the WINDOW so drawUprightFrame cover-fits straight into it: the
        // 0.3% window/photo aspect difference becomes a hairline crop. Rendering at OUTPUT size and then
        // scaling into the window is what squashed the emailed photo before.
        // (drawUprightFrame takes no offset args and clears its whole target, so it cannot draw onto ctx
        // directly — that would wipe the background fill.)
        var photoCanvas = document.createElement('canvas');
        photoCanvas.width = ww;
        photoCanvas.height = wh;
        drawUprightFrame(photoCanvas.getContext('2d'), ww, wh, frameSource, sx, sy, sWidth, sHeight, !isSquare, mirror);
        ctx.drawImage(photoCanvas, wx, wy, ww, wh);
        ctx.drawImage(gifImg, 0, 0, w, h); // native size => undistorted artwork
        // The name is a fraction of the box it is handed, and here the window IS the photo. Against the
        // full 9:16 canvas the default 12% line would land below the photo, in the frame's bottom margin.
        ctx.save();
        ctx.translate(wx, wy);
        drawUserInfo(ctx, ww, wh);
        ctx.restore();
      };

      // --- Création de l'image pour la preview (affichée sur l'écran de partage) ---
      // Full output resolution so the on-screen preview is as crisp as the final image (one-time
      // toDataURL, no per-frame cost).
      var previewCanvas = document.createElement('canvas');
      previewCanvas.width = OUTPUT_WIDTH; // taille de preview
      previewCanvas.height = OUTPUT_HEIGHT;
      var previewCtx = previewCanvas.getContext('2d');

      // Dessiner la vidéo avec crop (rotation +90° sauf en format carré 15x15), comme le canvas final.
      // The bare 2:3 photo, no frame: every consumer layers the frame itself as a DOM <img> over the same
      // box (the share screen) or positions this as the sheet inside the frame's window (the reveal).
      drawUprightFrame(previewCtx, previewCanvas.width, previewCanvas.height, frameSource, sx, sy, sWidth, sHeight, !isSquare, mirror);

      // NB: the user-info text is NOT baked into the preview canvas. On screen the animated filter
      // (live_frame_uri) is a DOM <img> layered on top of this preview image, so baked text would sit
      // behind it. Instead the info is rendered as a DOM element ABOVE the filter overlay (see render).
      // The print/share canvases DO bake it (drawn after the GIF), so the saved/printed image is correct.

      var previewData = previewCanvas.toDataURL('image/png');
      setCapturedPreview(previewData); // state pour preview

      // --- Canvas pour l'image à partager (GIF plein écran) ---
      var shareCanvas = document.createElement('canvas');
      // The frame's own pixels when it is a full-screen asset: this file is NOT a sheet, so it never takes
      // the 2:3 print size. Squeezing a 9:16 frame into 2:3 here is what squashed the download.
      shareCanvas.width = frameShare ? gifImg.naturalWidth : canvas.width;
      shareCanvas.height = frameShare ? gifImg.naturalHeight : canvas.height;
      var shareCtx = shareCanvas.getContext('2d');
      if (frameShare) {
        drawWindowedShare(shareCtx, shareCanvas.width, shareCanvas.height);
      } else {
        // Dessiner la vidéo (rotation +90° sauf en format carré 15x15)
        drawUprightFrame(shareCtx, shareCanvas.width, shareCanvas.height, frameSource, sx, sy, sWidth, sHeight, !isSquare, mirror);

        // Dessiner le GIF **plein écran**, sans scale ni offset
        if (gifImg) {
          shareCtx.drawImage(gifImg, 0, 0, shareCanvas.width, shareCanvas.height);
        }

        // Barre d'informations utilisateur (nom / prénom / date de naissance)
        drawUserInfo(shareCtx, shareCanvas.width, shareCanvas.height);
      }

      // Stocker dans l'état
      var shareData = shareCanvas.toDataURL('image/png');
      setShareImage(shareData);

      // --- Canvas principal pour l'impression (rotation +90° sauf en format carré 15x15) ---
      // Top-anchor the photo under a full-screen frame instead of centring it on the sheet. The window starts
      // REVEAL_WINDOW.top down the sheet, so a centred photo had that whole band cropped off its top (and only
      // 5.5% off the bottom). Shifting it down by the same amount puts the photo's top edge on the window's
      // top edge: the zoom is unchanged, but the crop now comes entirely off the bottom. print_photo_offset
      // nudges it per booth. Only applies to a full-screen frame — REVEAL_WINDOW means nothing for a frame
      // authored at 2:3 or 1:1, and those booths must not move.
      var printShiftY = frameShare ? Math.round((parseFloat(REVEAL_WINDOW.top) + printPhotoOffset) / 100 * canvas.height) : 0;
      if (printShiftY) {
        // Background FIRST, outside the translate: drawUprightFrame clears and fills only its own w x h, so
        // the band the photo has vacated would otherwise stay bare canvas wherever the frame is transparent.
        context.fillStyle = cell.background_color && !/rgba\(\s*0\s*,\s*0\s*,\s*0\s*,\s*0\s*\)/.test(cell.background_color) ? cell.background_color : '#FFFFFF';
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.save();
        context.translate(0, printShiftY);
        drawUprightFrame(context, canvas.width, canvas.height, frameSource, sx, sy, sWidth, sHeight, !isSquare, mirror);
        context.restore();
      } else {
        drawUprightFrame(context, canvas.width, canvas.height, frameSource, sx, sy, sWidth, sHeight, !isSquare, mirror);
      }

      // --- Superposer GIF seulement pour l'impression ---
      if (gifImg) {
        // const scale = 0.986; 
        // const gifWidth = canvas.width * scale; 
        // const gifHeight = canvas.height * scale; 
        // const mmToPx = (mm) => Math.round(mm * 300 / 25.4); 
        // const offsetX = mmToPx(1); 
        // const offsetY = mmToPx(0.3)
        // const gifX = (canvas.width - gifWidth) / 2 + offsetX; 
        // const gifY = (canvas.height - gifHeight) / 2 + offsetY; 
        // context.drawImage(gifImg, gifX, gifY, gifWidth, gifHeight);
        // Grande imprimante
        context.drawImage(gifImg, 0, 0, canvas.width, canvas.height);
      }

      // Barre d'informations utilisateur (nom / prénom / date de naissance)
      drawUserInfo(context, canvas.width, canvas.height);
      var imageData = canvas.toDataURL('image/png');
      setCapturedImage(imageData); // state pour l'impression / partage

      if (progressIntervalRef.current) clearInterval(progressIntervalRef.current);
      setProcessingProgress(100);
      setTimeout(function () {
        setIsProcessing(false);
        setProcessingProgress(0);
        // capturedImage / capturedPreview are both set synchronously above, so whichever step renders
        // next already has its image.
        setStep(fullscreenReveal ? 'reveal' : 'share');
      }, 300);
    } catch (error) {
      console.error('❌ Error processing photo capture:', error);
      if (progressIntervalRef.current) clearInterval(progressIntervalRef.current);
      setIsProcessing(false);
      setProcessingProgress(0);
    }
  };
  var capturePhoto = function capturePhoto() {
    fallbackCapturePhoto(); // Always use fallback to ensure GIF is drawn
    // console.log('treeosk-btn-' + cell.gpio_number);
  };
  var handleRetake = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            setCapturedImage(null);
            // Must also clear the preview and its decoded flag: the reveal overlay renders on capturedPreview
            // over the live feed, so a leftover value would cover the new session's camera with the old photo.
            setCapturedPreview(null);
            setRevealPhotoReady(false);
            setLink(''); // Reset link so it can be regenerated for new photo
            setIsSended(false); // Reset email sent status
            setPrinted(false);
            setPrintButtonText(textDatas.print);
            // Clear progress interval if still running
            if (progressIntervalRef.current) {
              clearInterval(progressIntervalRef.current);
              progressIntervalRef.current = null;
            }
            setIsProcessing(false); // Reset processing state
            setProcessingProgress(0); // Reset progress

            // Clean up existing camera stream
            if (streamRef.current) {
              streamRef.current.getTracks().forEach(function (track) {
                return track.stop();
              });
              streamRef.current = null;
            }
            if (videoRef.current) {
              videoRef.current.srcObject = null;
            }
            setHasCamera(false);
            setStep('camera');
          case 1:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return function handleRetake() {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleShare = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(e) {
      var emailValue, img, imageData, response, record, _t4;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            if (e) {
              e.preventDefault();
            }
            setSendStatus(null);
            emailValue = (email || '').trim();
            _context5.p = 1;
            if (!(emailValue && !EMAIL_RX.test(emailValue))) {
              _context5.n = 2;
              break;
            }
            throw new Error('Invalid email address');
          case 2:
            if (shareImage) {
              _context5.n = 3;
              break;
            }
            throw new Error('No captured image available');
          case 3:
            // Set sending state only after we start the actual upload
            setIsSending(true);

            // Use the original high-resolution capturedImage (OUTPUT_WIDTH×OUTPUT_HEIGHT — 1440×2160, or 2160² square) for digital/QR code
            // Convert PNG to high-quality JPEG to reduce file size while maintaining quality
            img = new Image();
            img.crossOrigin = 'anonymous';
            _context5.n = 4;
            return new Promise(function (resolve, reject) {
              img.onload = function () {
                // Create a canvas matching the loaded image natural size to avoid any squash/stretch
                var naturalW = img.naturalWidth || img.width;
                var naturalH = img.naturalHeight || img.height;
                var canvas = document.createElement('canvas');
                canvas.width = naturalW;
                canvas.height = naturalH;
                var ctx = canvas.getContext('2d');

                // Draw the image at its natural size
                ctx.drawImage(img, 0, 0, naturalW, naturalH);

                // Convert to high-quality JPEG (0.95 quality for good balance between size and quality)
                var jpegData = canvas.toDataURL('image/jpeg', 0.95);
                resolve(jpegData);
              };
              img.onerror = reject;
              img.src = shareImage;
            });
          case 4:
            imageData = _context5.v;
            setImageUrl(imageData);
            _context5.n = 5;
            return fetch("".concat(project.backEndUri, "/send_photo"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                cell_id: cell.id,
                image: imageData,
                // Utiliser l'image capturée
                email: emailValue,
                consent: consent,
                terms: terms,
                // Le sujet/corps/expéditeur du mail sont résolus côté back à partir de cell_id : on
                // n'envoie que la langue courante pour qu'il choisisse la bonne traduction.
                language_code: intl && intl.locale,
                project_id: project.id
              })
            });
          case 5:
            response = _context5.v;
            if (response.ok) {
              _context5.n = 6;
              break;
            }
            throw new Error('Upload failed');
          case 6:
            _context5.n = 7;
            return response.json();
          case 7:
            record = _context5.v;
            setSendStatus('success');
            setLink(record.image_uri);
            setEmail('');
            setConsent(false);
            if (emailValue) {
              setIsSended(true);
            }

            // Only set isSending to false after link is set and QR code can render
            setIsSending(false);
            _context5.n = 9;
            break;
          case 8:
            _context5.p = 8;
            _t4 = _context5.v;
            setSendStatus('error: ' + _t4);
            setIsSending(false);
          case 9:
            return _context5.a(2);
        }
      }, _callee5, null, [[1, 8]]);
    }));
    return function handleShare(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  // Textes par défaut (repli). Les champs éditables de la cellule, quand ils sont renseignés,
  // priment via i18nData(cell, '<champ>_text', ...) aux points d'affichage (look/buttonTake/
  // buttonDownload/conditions). NB : `description` (description_text) et `conditions2`
  // (conditions2_text) ne sont affichés nulle part dans la mise en page actuelle de la cellule —
  // les renseigner dans l'admin n'a donc aucun effet tant qu'aucun point d'affichage n'est ajouté.
  (0, _react.useEffect)(function () {
    switch (intl.locale) {
      case 'fr':
        setTextDatas({
          description: 'Recevez la photo par e-mail ou scannez le code QR.',
          buttonDownload: 'Telecharger la photo',
          buttonRetake: 'Retake Photo',
          buttonTake: 'Touchez pour commencer',
          send: 'Envoyer',
          sendByEmail: 'Recevoir la photo par email',
          // <-- ajouté
          conditions: "J'accepte de recevoir ma photo par email",
          conditions2: "J'ai lu et j'accepte les conditions générales.",
          sent: 'Votre photo a bien été envoyée',
          look: 'Regardez la caméra',
          preparingPhoto: 'Photo en cours de préparation...',
          almostThere: 'On y est presque...',
          emailPlaceholder: 'EMAIL',
          printed: 'IMPRIMER',
          print: 'IMPRESSION'
        });
        break;
      case 'nl':
        setTextDatas({
          description: 'Ontvang de foto per e-mail of scan de QR-code.',
          buttonDownload: 'Download de foto',
          buttonRetake: 'Hernoemen',
          buttonTake: 'Maak een foto',
          send: 'Verzenden',
          sendByEmail: 'Verzenden per e-mail',
          // <-- ajouté
          conditions: 'Ik ga akkoord met het ontvangen van de foto op mijn e-mailadres',
          conditions2: 'Ik heb de algemene voorwaarden gelezen en ga ermee akkoord.',
          sent: 'Foto verzonden!',
          look: 'Kijk naar de camera',
          preparingPhoto: 'Foto voorbereiden...',
          almostThere: 'Bijna klaar...',
          emailPlaceholder: 'EMAIL',
          printed: 'AFGEDRUKT',
          print: 'AFDRUKKEN'
        });
        break;
      case 'en':
        setTextDatas({
          description: 'Receive the photo by email or scan the QR code.',
          buttonDownload: 'Download Photo',
          buttonRetake: 'Retake Photo',
          buttonTake: 'Touch to start',
          send: 'Send',
          sendByEmail: 'Send by email',
          // <-- ajouté
          conditions: 'I agree to receive the photo at my email address',
          conditions2: 'I have read and agree to the terms and conditions.',
          sent: 'Photo sent!',
          look: 'Look at the camera',
          preparingPhoto: 'Preparing photo...',
          almostThere: 'Almost there...',
          emailPlaceholder: 'EMAIL',
          printed: 'PRINTED',
          print: 'PRINT'
        });
        break;
      case 'de':
        setTextDatas({
          description: 'Erhalten Sie das Foto per E-Mail oder scannen Sie den QR-Code.',
          buttonDownload: 'Foto herunterladen',
          buttonRetake: 'Foto erneut aufnehmen',
          buttonTake: 'Foto aufnehmen',
          send: 'Senden',
          sendByEmail: 'Per E-Mail senden',
          // <-- ajouté
          conditions: 'Ich stimme zu, das Foto an meine E-Mail-Adresse zu erhalten',
          conditions2: 'Ich habe die Allgemeinen Geschäftsbedingungen gelesen und akzeptiere sie.',
          sent: 'Foto gesendet!',
          look: 'Schau in die Kamera',
          preparingPhoto: 'Foto wird vorbereitet...',
          almostThere: 'Fast fertig...',
          emailPlaceholder: 'EMAIL',
          printed: 'GEDRUCKT',
          print: 'DRUCKEN'
        });
        break;
      case 'es':
        setTextDatas({
          description: 'Recibe la foto por correo electrónico o escanea el código QR.',
          buttonDownload: 'Descargar foto',
          buttonRetake: 'Volver a tomar la foto',
          buttonTake: 'Tomar foto',
          send: 'Enviar',
          sendByEmail: 'Enviar por correo',
          // <-- ajouté
          conditions: 'Acepto recibir la foto en mi dirección de correo electrónico',
          conditions2: 'He leído y acepto los términos y condiciones.',
          sent: '¡Foto enviada!',
          look: 'Mira a la cámara',
          preparingPhoto: 'Preparando foto...',
          almostThere: 'Casi listo...',
          emailPlaceholder: 'EMAIL',
          printed: 'IMPRESO',
          print: 'IMPRIMIR'
        });
        break;
      default:
        setTextDatas({
          description: 'Receive the photo by email or scan the QR code.',
          buttonDownload: 'Download Photo',
          buttonRetake: 'Retake Photo',
          buttonTake: 'Take Photo',
          send: 'Send',
          sendByEmail: 'Send by email',
          // <-- ajouté
          conditions: 'I agree to receive the photo at my email address',
          conditions2: 'I have read and agree to the terms and conditions.',
          sent: 'Photo sent!',
          look: 'Look at the camera',
          preparingPhoto: 'Preparing photo...',
          almostThere: 'Almost there...',
          emailPlaceholder: 'EMAIL',
          printed: 'PRINTED',
          print: 'PRINT'
        });
        break;
    }
  }, [intl.locale, defaultLanguage]);
  return /*#__PURE__*/_react.default.createElement(BackgroundWrapper, {
    style: _objectSpread({
      color: cell.text_color,
      fontFamily: font,
      '--text-scale': cell.text_size || 1
    }, cell.letter_spacing ? {
      letterSpacing: "".concat(cell.letter_spacing, "px")
    } : {})
  }, /*#__PURE__*/_react.default.createElement(Container, null, step === 'info' && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      // Sit a bit below dead-center so the form isn't too high on tall screens; leaves room
      // for the on-screen keyboard, which is anchored just under the card.
      paddingTop: '12vh',
      boxSizing: 'border-box',
      zIndex: 200
    }
  }, /*#__PURE__*/_react.default.createElement(EmailCard, {
    style: {
      marginRight: 0,
      width: 480,
      padding: '24px 0',
      transform: 'scale(1.35)',
      transformOrigin: 'center',
      background: cell.user_info_bar_color || undefined
    },
    ref: emailCardRef
  }, /*#__PURE__*/_react.default.createElement(CardTitle, {
    color: "#ffffff"
  }, intl.formatMessage({
    id: 'projects.photobooth.gif.userinfo.title',
    defaultMessage: 'Entrez vos informations'
  })), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: '#fff',
      fontFamily: font,
      fontSize: 14,
      alignSelf: 'flex-start',
      marginLeft: '5%'
    }
  }, intl.formatMessage({
    id: 'projects.photobooth.gif.userinfo.firstname',
    defaultMessage: 'Prénom'
  })), /*#__PURE__*/_react.default.createElement(EmailInput, {
    style: activeInfoField === 'firstname' ? {
      outline: '2px solid #fff'
    } : undefined,
    onClick: function onClick() {
      setActiveInfoField('firstname');
      setKeyboardVisible(true);
    }
  }, userFirstName || ''), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: '#fff',
      fontFamily: font,
      fontSize: 14,
      alignSelf: 'flex-start',
      marginLeft: '5%'
    }
  }, intl.formatMessage({
    id: 'projects.photobooth.gif.userinfo.surname',
    defaultMessage: 'Nom'
  })), /*#__PURE__*/_react.default.createElement(EmailInput, {
    style: activeInfoField === 'surname' ? {
      outline: '2px solid #fff'
    } : undefined,
    onClick: function onClick() {
      setActiveInfoField('surname');
      setKeyboardVisible(true);
    }
  }, userSurname || ''), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: '#fff',
      fontFamily: font,
      fontSize: 14,
      alignSelf: 'flex-start',
      marginLeft: '5%'
    }
  }, intl.formatMessage({
    id: 'projects.photobooth.gif.userinfo.birthdate',
    defaultMessage: 'Date de naissance'
  })), /*#__PURE__*/_react.default.createElement(EmailInput, {
    style: activeInfoField === 'birthdate' ? {
      outline: '2px solid #fff'
    } : undefined,
    onClick: function onClick() {
      setActiveInfoField('birthdate');
      setKeyboardVisible(true);
    }
  }, userBirthdate || 'JJ-MM-AAAA'), /*#__PURE__*/_react.default.createElement(SendButton, {
    style: {
      background: cell.button_retake_background_color
    },
    onClick: function onClick() {
      setKeyboardVisible(false);
      setActiveInfoField(null);
      setStep('camera');
    },
    disabled: !userFirstName || !userSurname || !userBirthdate
  }, intl.formatMessage({
    id: 'projects.photobooth.gif.userinfo.continue',
    defaultMessage: 'Continuer'
  }))), keyboardVisible && activeInfoField && /*#__PURE__*/_react.default.createElement(_AzertyKeyboard.default, {
    field_name: activeInfoField,
    setVisible: setKeyboardVisible,
    project: project,
    input: activeInfoField === 'firstname' ? userFirstName : activeInfoField === 'surname' ? userSurname : userBirthdate,
    setInput: activeInfoField === 'firstname' ? setUserFirstName : activeInfoField === 'surname' ? setUserSurname : setBirthdateMasked,
    anchorRef: emailCardRef
  })), (step === 'camera' || step === 'countdown') && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(CameraContainer, {
    className: "camera-container",
    ref: cameraContainerRef,
    cameraReady: hasCamera,
    square: isSquare,
    loaderBg: cell.loader_background_color
  }, /*#__PURE__*/_react.default.createElement(CameraBox, {
    square: isSquare,
    windowed: fullscreenPreview,
    ref: cameraBoxRef
  }, !hasCamera && /*#__PURE__*/_react.default.createElement(Spinner, {
    color: cell.loader_spinner_color
  }), /*#__PURE__*/_react.default.createElement(VideoPreview, {
    ref: videoRef,
    autoPlay: true,
    playsInline: true,
    muted: true,
    mirror: mirror,
    square: isSquare,
    style: {
      display: hasCamera ? 'block' : 'none',
      // <--- invisible tant que pas prêt
      // Hidden visually: the PreviewCanvas shows the feed now. The video stays in the
      // DOM and playing (opacity, not display:none) so it remains a valid capture source.
      opacity: 0
    }
    // style={{ display: isProcessing && frozenFrame ? 'none' : 'block' }}
  }), /*#__PURE__*/_react.default.createElement(PreviewCanvas, {
    ref: displayCanvasRef,
    mirror: false,
    style: {
      display: hasCamera ? 'block' : 'none'
    }
  }), hasCamera && cell.collect_user_info && (userFirstName || userSurname || userBirthdate) && /*#__PURE__*/_react.default.createElement(UserInfoOverlay, {
    boxH: cameraBoxH,
    sizeScale: cell.user_info_text_size || 1,
    posPct: (cell.user_info_text_position != null ? cell.user_info_text_position : 12) / 100,
    hPosPct: (cell.user_info_text_h_position != null ? cell.user_info_text_h_position : 50) / 100,
    color: cell.user_info_text_color,
    font: font,
    firstName: userFirstName,
    surname: userSurname,
    birthdate: userBirthdate
  }), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, live_frame_uri && !fullscreenPreview && /*#__PURE__*/_react.default.createElement(GifOverlay, {
    src: live_frame_uri,
    alt: "Frame overlay"
  }), step === 'countdown' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, countdown > 0 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, countdown > photoTimer ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'absolute',
      top: '20%',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 16000,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(AnimatedArrows, {
    cell: cell,
    font: font,
    intl: intl,
    textDatas: textDatas
  }), /*#__PURE__*/_react.default.createElement(ButtonText, {
    style: {
      color: cell.look_text_color || cell.text_color
    }
  }, (0, _utils.i18nData)(cell, 'look_text', intl, defaultLanguage) || textDatas.look))) : /*#__PURE__*/
  // Countdown numbers: descending (3,2,1) or ascending (1,2,3) per admin config.
  _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(CountdownOverlay, null, /*#__PURE__*/_react.default.createElement(CountdownNumber, null, countUp ? photoTimer - countdown + 1 : countdown)))) :
  // Dès que countdown = 0, on affiche le processing
  isProcessing && /*#__PURE__*/_react.default.createElement(ProgressBarContainer, null, /*#__PURE__*/_react.default.createElement(ProgressText, {
    uppercase: fullscreenReveal
  }, processingProgress < 50 ? (0, _utils.i18nData)(cell, 'preparing_photo_text', intl, defaultLanguage) || textDatas.preparingPhoto || "Preparing photo..." : (0, _utils.i18nData)(cell, 'almost_there_text', intl, defaultLanguage) || textDatas.almostThere || "Almost there..."), /*#__PURE__*/_react.default.createElement(ProgressBarWrapper, null, /*#__PURE__*/_react.default.createElement(ProgressBarFill, {
    progress: processingProgress
  }))))), fullscreenReveal && revealPhotoSrc && /*#__PURE__*/_react.default.createElement(InBoxPhoto, {
    src: revealPhotoSrc,
    alt: "",
    visible: revealPhotoReady,
    onLoad: function onLoad() {
      return setRevealPhotoReady(true);
    }
  }))), step !== 'countdown' && /*#__PURE__*/_react.default.createElement(ControlBar, {
    windowed: fullscreenPreview
  }, /*#__PURE__*/_react.default.createElement(CameraButton, {
    onClick: handleTakePhoto,
    style: fullscreenPreview ? {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    } : undefined
  }, /*#__PURE__*/_react.default.createElement(ButtonText, {
    style: _objectSpread({
      color: cell.button_take_text_color || cell.text_color
    }, fullscreenPreview ? {
      marginTop: 0
    } : {})
  }, "  ", (0, _utils.i18nData)(cell, 'button_take_text', intl, defaultLanguage) || textDatas.buttonTake)))), step === 'reveal' && capturedImage && /*#__PURE__*/_react.default.createElement(FullscreenPhoto, {
    onClick: function onClick() {
      return setStep('share');
    }
  }, /*#__PURE__*/_react.default.createElement(WindowedPhoto, {
    src: capturedPreview || capturedImage,
    alt: "",
    visible: true
  })), fullscreenPreview && live_frame_uri && (step === 'camera' || step === 'countdown' || step === 'reveal') && /*#__PURE__*/_react.default.createElement(FullscreenGifOverlay, {
    src: live_frame_uri,
    alt: "Frame overlay"
  }), step === 'camera' && cell.change_bg_page_id && linkFromPageId && typeof document !== 'undefined' && /*#__PURE__*/_reactDom.default.createPortal(/*#__PURE__*/_react.default.createElement(ChangeBgBar, {
    style: {
      top: "".concat(cell.change_bg_button_position != null ? cell.change_bg_button_position : 8, "%"),
      fontFamily: font,
      '--text-scale': cell.text_size || 1
    }
  }, linkFromPageId(cell.change_bg_page_id, /*#__PURE__*/_react.default.createElement(ChangeBgButton, null, (0, _utils.i18nData)(cell, 'change_bg_text', intl, defaultLanguage) || cell.change_bg_text || 'Change background'), {
    style: {
      textDecoration: 'none'
    }
  })), document.body), step === 'share' && cell.links_to_page_id && linkFromPageId && linkFromPageId(cell.links_to_page_id, /*#__PURE__*/_react.default.createElement(CornerLink, null), {
    style: CORNER_LINK_STYLE
  }), step === 'share' && fullscreenReveal && /*#__PURE__*/_react.default.createElement(ShareColumn, {
    gap: shareColumnGap
  }, /*#__PURE__*/_react.default.createElement(SecondaryButton, {
    textBold: cell.button_retake_text_bold,
    style: {
      background: cell.button_retake_background_color,
      color: cell.button_retake_text_color,
      border: cell.button_retake_border_color ? "0.3em solid ".concat(cell.button_retake_border_color) : 'none',
      borderRadius: buttonRadius(project),
      width: COLUMN_BUTTON.width,
      height: COLUMN_BUTTON.height,
      padding: COLUMN_BUTTON.padding,
      margin: 0,
      fontSize: "calc(23px * var(--text-scale, 1) * ".concat(retakeTextScale, ")"),
      whiteSpace: 'nowrap'
    },
    onClick: handleRetake
  }, (0, _utils.i18nData)(cell, 'button_retake_text', intl, defaultLanguage) || textDatas.buttonRetake), showQRCode && cell.qr_code && /*#__PURE__*/
  /* marginRight overrides the shared card's 31px side-by-side gutter, which would offset it
     from center in a column. backdropFilter is cleared because ShareOptionCard frosts what's
     behind the card — that reads as an opaque haze even when the color is fully transparent.
     width:auto because the card is fixed at 240px, which would clip a larger QR. */
  _react.default.createElement(QRCodeCard, {
    style: {
      background: cell.qr_card_background_color || 'transparent',
      marginRight: 0,
      minHeight: 0,
      width: 'auto',
      backdropFilter: 'none',
      WebkitBackdropFilter: 'none'
    }
  }, /*#__PURE__*/_react.default.createElement(CardTitle, {
    color: cell.text_color || '#000000',
    textBold: cell.qr_title_bold,
    style: {
      fontSize: "calc(18px * var(--text-scale, 1) * ".concat(qrTitleScale, ")"),
      height: 'auto',
      padding: '0.3em 0',
      marginBottom: '0.8em'
    }
  }, (0, _utils.i18nData)(cell, 'button_download_text', intl, defaultLanguage) || textDatas.buttonDownload), /*#__PURE__*/_react.default.createElement(QRCodeDisplay, {
    style: {
      margin: '0 auto',
      width: qrSize,
      height: qrSize
    }
  }, link ? /*#__PURE__*/_react.default.createElement(_qrcode.QRCodeSVG, {
    value: link,
    size: qrSize,
    bgColor: "transparent",
    fgColor: cell.qr_code_color || '#000000'
  }) : /*#__PURE__*/_react.default.createElement(Spinner, {
    color: cell.loader_spinner_color || cell.text_color || '#000000',
    style: {
      position: 'static',
      margin: 0,
      width: '60px',
      height: '60px'
    }
  }))), showPrint && cell.print && /*#__PURE__*/_react.default.createElement(PrintGroup, null, ((0, _utils.i18nData)(cell, 'print_title_text', intl, defaultLanguage) || cell.print_title_text) && /*#__PURE__*/_react.default.createElement(CardTitle, {
    color: cell.text_color || '#000000',
    textBold: cell.print_title_bold,
    style: {
      fontSize: "calc(18px * var(--text-scale, 1) * ".concat(printTitleScale, ")"),
      height: 'auto',
      padding: '0.3em 0',
      margin: '0 0 0.8em 0'
    }
  }, (0, _utils.i18nData)(cell, 'print_title_text', intl, defaultLanguage) || cell.print_title_text), /*#__PURE__*/_react.default.createElement(ColumnPrintCard, {
    style: {
      background: printed ? PRINT_TAPPED_GREY : cell.button_print_background_color || cell.button_retake_background_color,
      borderRadius: buttonRadius(project)
    },
    onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
      var isPanini, toPrint, _t5;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            if (!(!capturedImage || printed)) {
              _context6.n = 1;
              break;
            }
            return _context6.a(2);
          case 1:
            // Panini (portrait only): print 4 copies in a 2x2 grid; otherwise the single photo.
            isPanini = paniniPrint && !isSquare;
            toPrint = capturedImage;
            if (!isPanini) {
              _context6.n = 5;
              break;
            }
            _context6.p = 2;
            _context6.n = 3;
            return buildPaniniImage(capturedImage);
          case 3:
            toPrint = _context6.v;
            _context6.n = 5;
            break;
          case 4:
            _context6.p = 4;
            _t5 = _context6.v;
            console.error('Panini composite failed, printing single photo:', _t5);
          case 5:
            printImageData(toPrint, isPanini);
            setPrintButtonText(textDatas.printed);
          case 6:
            return _context6.a(2);
        }
      }, _callee6, null, [[2, 4]]);
    })),
    disabled: printed
  }, /*#__PURE__*/_react.default.createElement(PrintButton, {
    textScale: printTextScale,
    textBold: cell.print_text_bold
  }, printed ? (0, _utils.i18nData)(cell, 'printed_text', intl, defaultLanguage) || textDatas.printed || 'PRINTED' : (0, _utils.i18nData)(cell, 'print_text', intl, defaultLanguage) || textDatas.print || 'PRINT'))), cell.share_link_page_id && linkFromPageId && linkFromPageId(cell.share_link_page_id, /*#__PURE__*/_react.default.createElement(ColumnLinkCard, {
    style: {
      background: cell.share_link_background_color,
      color: cell.share_link_text_color,
      // Like the retake button: no border unless the admin picked one — defaulting to
      // #FFFFFF draws a white outline on every booth.
      border: cell.share_link_border_color ? "0.3em solid ".concat(cell.share_link_border_color) : 'none',
      borderRadius: buttonRadius(project)
    }
  }, (0, _utils.i18nData)(cell, 'share_link_text', intl, defaultLanguage) || cell.share_link_text), {
    style: {
      textDecoration: 'none'
    }
  })), step === 'share' && !fullscreenReveal && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Preview, {
    step: step,
    style: {
      color: cell.text_color
    }
  }, /*#__PURE__*/_react.default.createElement(PreviewWrapper2, {
    id: "preview-wrapper",
    square: isSquare,
    previewWidth: sharePreviewWidth,
    offset: sharePreviewOffset
  }, capturedImage && /*#__PURE__*/_react.default.createElement("div", {
    id: "preview-wrapper",
    style: {
      position: 'relative',
      width: '100%',
      // Square mode: a 1:1 box (height derived from width) so the square preview shows fully.
      height: isSquare ? 'auto' : '100%',
      aspectRatio: isSquare ? '1 / 1' : undefined,
      background: 'transparent',
      border: 'none',
      boxShadow: 'none',
      outline: 'none'
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: capturedImage,
    alt: "Preview avec rotation",
    crossOrigin: "anonymous",
    style: {
      display: 'block',
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      border: 'none',
      boxShadow: 'none',
      outline: 'none'
    }
  })))), /*#__PURE__*/_react.default.createElement(ShareOptionsContainer, {
    square: isSquare,
    offset: shareControlsOffset
  }, cell.email && /*#__PURE__*/_react.default.createElement(EmailCard, {
    ref: emailCardRef,
    style: cell.email_card_background_color ? {
      background: cell.email_card_background_color
    } : undefined
  }, /*#__PURE__*/_react.default.createElement(CardTitle, {
    color: "#ffffff"
  }, (0, _utils.i18nData)(cell, 'send_by_email_text', intl, defaultLanguage) || textDatas.sendByEmail), /*#__PURE__*/_react.default.createElement(EmailInput, {
    style: _objectSpread(_objectSpread({}, cell.email_input_background_color ? {
      background: cell.email_input_background_color
    } : {}), cell.email_input_text_color ? {
      color: cell.email_input_text_color
    } : {}),
    onClick: function onClick() {
      setKeyboardVisible(true);
    }
  }, email || (0, _utils.i18nData)(cell, 'email_placeholder_text', intl, defaultLanguage) || textDatas.emailPlaceholder || 'EMAIL'), /*#__PURE__*/_react.default.createElement(SendButton, {
    style: _objectSpread({
      // Falls back to the Retake button's color, as before, so existing booths look the same.
      background: cell.send_button_background_color || cell.button_retake_background_color
    }, cell.send_button_text_color ? {
      color: cell.send_button_text_color
    } : {}),
    onClick: function onClick(e) {
      if (isSending) return;
      e.preventDefault();
      e.stopPropagation();
      handleShare(e);
    },
    disabled: !email || !consent || isSending
  }, (0, _utils.i18nData)(cell, 'send', intl, defaultLanguage) || textDatas.send), email && typeof sendStatus === 'string' && sendStatus.startsWith('error') && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: '#ffb4b4',
      fontSize: '0.8rem',
      marginTop: '0.5rem',
      textAlign: 'center',
      width: '90%'
    }
  }, sendStatus.includes('Invalid email') ? sendErrorTexts(intl && intl.locale).invalidEmail : sendErrorTexts(intl && intl.locale).failed), isSended && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: 'green',
      fontSize: '0.8rem',
      marginTop: '0.5rem'
    }
  }, (0, _utils.i18nData)(cell, 'sent_text', intl, defaultLanguage) || textDatas.sent), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
      marginTop: '0.5rem',
      width: '90%'
    }
  }, /*#__PURE__*/_react.default.createElement(ShareCheckbox, {
    style: {
      fontFamily: font,
      fontSize: '0.5rem'
    }
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "checkbox",
    checked: consent,
    onChange: function onChange(e) {
      return setConsent(e.target.checked);
    }
  }), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: '#fff',
      fontFamily: font
    }
  }, (0, _utils.i18nData)(cell, 'conditions1_text', intl, defaultLanguage) || textDatas.conditions)))), showQRCode && cell.qr_code && /*#__PURE__*/_react.default.createElement(QRCodeCard, {
    style: {
      background: cell.qr_card_background_color || 'rgba(122, 103, 66, 0.2)'
    }
  }, /*#__PURE__*/_react.default.createElement(CardTitle, {
    color: "#ffffff",
    textBold: cell.qr_title_bold,
    style: {
      fontSize: "calc(18px * var(--text-scale, 1) * ".concat(qrTitleScale, ")"),
      minHeight: '60px',
      height: 'auto'
    }
  }, (0, _utils.i18nData)(cell, 'button_download_text', intl, defaultLanguage) || textDatas.buttonDownload), /*#__PURE__*/_react.default.createElement(QRCodeDisplay, null, link ? /*#__PURE__*/_react.default.createElement(_qrcode.QRCodeSVG, {
    value: link,
    size: 120,
    bgColor: "transparent",
    fgColor: cell.qr_code_color || '#000000'
  }) : /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '120px',
      height: '120px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '60px',
      height: '60px',
      border: '4px solid rgba(122, 103, 66, 0.3)',
      borderTop: '4px solid #7A6742',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite'
    }
  }), /*#__PURE__*/_react.default.createElement("style", null, "\n                        @keyframes spin {\n                          0% { transform: rotate(0deg); }\n                          100% { transform: rotate(360deg); }\n                        }\n                      ")))), showPrint && cell.print && /*#__PURE__*/_react.default.createElement(PrintCard, {
    style: {
      background: printed ? PRINT_TAPPED_GREY : cell.button_print_background_color || cell.button_retake_background_color
    },
    onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
      var isPanini, toPrint, _t6;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            if (!(!capturedImage || printed)) {
              _context7.n = 1;
              break;
            }
            return _context7.a(2);
          case 1:
            // Panini (portrait only): print 4 copies in a 2x2 grid; otherwise the single photo.
            isPanini = paniniPrint && !isSquare;
            toPrint = capturedImage;
            if (!isPanini) {
              _context7.n = 5;
              break;
            }
            _context7.p = 2;
            _context7.n = 3;
            return buildPaniniImage(capturedImage);
          case 3:
            toPrint = _context7.v;
            _context7.n = 5;
            break;
          case 4:
            _context7.p = 4;
            _t6 = _context7.v;
            console.error('Panini composite failed, printing single photo:', _t6);
          case 5:
            // Pass isPanini so Electron uses the true-centered 6×4 page (no fudge) for cutting.
            printImageData(toPrint, isPanini);
            setPrintButtonText(textDatas.printed);
          case 6:
            return _context7.a(2);
        }
      }, _callee7, null, [[2, 4]]);
    })),
    disabled: printed
  }, /*#__PURE__*/_react.default.createElement(PrintIconContainer, null, /*#__PURE__*/_react.default.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "SVGRepo_bgCarrier",
    "stroke-width": "0"
  }), /*#__PURE__*/_react.default.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), /*#__PURE__*/_react.default.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6 17.9827C4.44655 17.9359 3.51998 17.7626 2.87868 17.1213C2 16.2426 2 14.8284 2 12C2 9.17157 2 7.75736 2.87868 6.87868C3.75736 6 5.17157 6 8 6H16C18.8284 6 20.2426 6 21.1213 6.87868C22 7.75736 22 9.17157 22 12C22 14.8284 22 16.2426 21.1213 17.1213C20.48 17.7626 19.5535 17.9359 18 17.9827",
    stroke: "white",
    "stroke-width": "1.5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9 10H6",
    stroke: "white",
    "stroke-width": "1.5",
    "stroke-linecap": "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19 14L5 14",
    stroke: "white",
    "stroke-width": "1.5",
    "stroke-linecap": "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.1213 2.87868L16.591 3.40901V3.40901L17.1213 2.87868ZM6.87868 2.87868L7.40901 3.40901V3.40901L6.87868 2.87868ZM6.87868 21.1213L7.40901 20.591H7.40901L6.87868 21.1213ZM18.75 14C18.75 13.5858 18.4142 13.25 18 13.25C17.5858 13.25 17.25 13.5858 17.25 14H18.75ZM6.75 14C6.75 13.5858 6.41421 13.25 6 13.25C5.58579 13.25 5.25 13.5858 5.25 14H6.75ZM17.25 16C17.25 17.4354 17.2484 18.4365 17.1469 19.1919C17.0482 19.9257 16.8678 20.3142 16.591 20.591L17.6517 21.6517C18.2536 21.0497 18.5125 20.2919 18.6335 19.3918C18.7516 18.5132 18.75 17.393 18.75 16H17.25ZM12 22.75C13.393 22.75 14.5132 22.7516 15.3918 22.6335C16.2919 22.5125 17.0497 22.2536 17.6517 21.6517L16.591 20.591C16.3142 20.8678 15.9257 21.0482 15.1919 21.1469C14.4365 21.2484 13.4354 21.25 12 21.25V22.75ZM12 2.75C13.4354 2.75 14.4365 2.75159 15.1919 2.85315C15.9257 2.9518 16.3142 3.13225 16.591 3.40901L17.6517 2.34835C17.0497 1.74643 16.2919 1.48754 15.3918 1.36652C14.5132 1.24841 13.393 1.25 12 1.25V2.75ZM12 1.25C10.607 1.25 9.48678 1.24841 8.60825 1.36652C7.70814 1.48754 6.95027 1.74643 6.34835 2.34835L7.40901 3.40901C7.68577 3.13225 8.07434 2.9518 8.80812 2.85315C9.56347 2.75159 10.5646 2.75 12 2.75V1.25ZM5.25 16C5.25 17.393 5.24841 18.5132 5.36652 19.3918C5.48754 20.2919 5.74643 21.0497 6.34835 21.6517L7.40901 20.591C7.13225 20.3142 6.9518 19.9257 6.85315 19.1919C6.75159 18.4365 6.75 17.4354 6.75 16H5.25ZM12 21.25C10.5646 21.25 9.56347 21.2484 8.80812 21.1469C8.07435 21.0482 7.68577 20.8678 7.40901 20.591L6.34835 21.6517C6.95027 22.2536 7.70814 22.5125 8.60825 22.6335C9.48678 22.7516 10.607 22.75 12 22.75V21.25ZM18.7323 5.97741C18.6859 4.43521 18.5237 3.22037 17.6517 2.34835L16.591 3.40901C17.0016 3.8196 17.1859 4.4579 17.233 6.02259L18.7323 5.97741ZM6.76698 6.02259C6.81413 4.4579 6.99842 3.8196 7.40901 3.40901L6.34835 2.34835C5.47633 3.22037 5.31413 4.43521 5.26766 5.97741L6.76698 6.02259ZM18.75 16V14H17.25V16H18.75ZM6.75 16V14H5.25V16H6.75Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "17",
    cy: "10",
    r: "1",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15 16.5H9",
    stroke: "white",
    "stroke-width": "1.5",
    "stroke-linecap": "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13 19H9",
    stroke: "white",
    "stroke-width": "1.5",
    "stroke-linecap": "round"
  })))), /*#__PURE__*/_react.default.createElement(PrintButton, {
    textScale: printTextScale,
    textBold: cell.print_text_bold
  }, printed ? (0, _utils.i18nData)(cell, 'printed_text', intl, defaultLanguage) || textDatas.printed || 'PRINTED' : (0, _utils.i18nData)(cell, 'print_text', intl, defaultLanguage) || textDatas.print || 'PRINT'))), /*#__PURE__*/_react.default.createElement(ButtonGroup, {
    square: isSquare,
    offset: shareControlsOffset
  }, /*#__PURE__*/_react.default.createElement(SecondaryButton, {
    textScale: retakeTextScale,
    textBold: cell.button_retake_text_bold,
    style: {
      background: cell.button_retake_background_color,
      color: cell.button_retake_text_color,
      border: "0.3em solid ".concat(cell.button_retake_border_color || '#FFFFFF')
    },
    onClick: handleRetake
  }, (0, _utils.i18nData)(cell, 'button_retake_text', intl, defaultLanguage) || textDatas.buttonRetake)), keyboardVisible && cell.email && /*#__PURE__*/_react.default.createElement(_AzertyKeyboard.default, {
    field_name: 'Email',
    setVisible: setKeyboardVisible,
    project: project,
    input: email,
    setInput: setEmail,
    anchorRef: emailCardRef
  })), /*#__PURE__*/_react.default.createElement("canvas", {
    ref: previewCanvasRef,
    width: OUTPUT_WIDTH,
    height: OUTPUT_HEIGHT,
    style: {
      display: 'none',
      width: "".concat(OUTPUT_WIDTH, "px"),
      height: "".concat(OUTPUT_HEIGHT, "px")
    }
  })));
}
function AnimatedArrows(_ref72) {
  var cell = _ref72.cell;
  // One admin color paints all three strokes; unset keeps the original white/grey/dark fade, which
  // is what gives the arrows their sense of depth.
  var arrowsColor = cell && cell.arrows_color;
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "70",
    height: "80",
    viewBox: "0 0 24 48"
  }, /*#__PURE__*/_react.default.createElement("style", null, "\n            .moveUp {\n              animation: moveUp 0.8s ease-in-out infinite alternate;\n              transform-origin: 50% 50%;\n              transform-box: fill-box;\n            }\n\n            @keyframes moveUp {\n              0% { transform: translateY(0); }\n              100% { transform: translateY(-6px); }\n            }\n          "), /*#__PURE__*/_react.default.createElement("g", {
    className: "moveUp"
  }, /*#__PURE__*/_react.default.createElement("polyline", {
    points: "5 10 12 3 19 10",
    fill: "none",
    stroke: arrowsColor || "#ffffff",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("polyline", {
    points: "5 20 12 13 19 20",
    fill: "none",
    stroke: arrowsColor || "#bbbbbb",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("polyline", {
    points: "5 30 12 23 19 30",
    fill: "none",
    stroke: arrowsColor || "#333333",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}